<template>
  <v-card
    id="listener_Produzione2"
    style="text-align: center; padding: 20px; height: 100%"
  >
    <CarrelloLayout
      :back_as_landing_page="back_as_landing_page"
      @click_allegati_commessa="handleClickAllegatiCommessa"
      @click_aggiungi="getWorkOrders()"
      @click_chiusura_massiva_fasi="handleClickChiusuraMassivaFasi"
      @click_registra_art_res="handleClickRegistraArtRes"
      @click_registra_peso="handleClickRegistraPeso"
      @click_riapertura_master="handleClickRiaperturaMaster"
      @click_allegati_fase="handleAllegatiFase"
      @click_applicazione_loghi="handleClickApplicazioneLoghi"
      @click_avanza_confezioni="clickAvanzaConfezioni"
      @click_avanza_contenitore="clickAvanzaContenitore"
      @click_avanza_contenitore_sf="clickAvanzaContenitoreSF"
      @click_check="handleClickCheck"
      @click_manutenzione="handleClickManutenzione"
      @click_campionatura="handleCampionatura"
      @click_chiusura_fase="handleChiusuraFase"
      @click_controllo_mp="handleControlloMP"
      @click_controllo_qualita="handleControlloQualita"
      @click_history="handleClickHistory"
      @click_indietro="handleClickIndietro"
      @click_lavoro_squadra="handleClickLavoroSquadra"
      @click_nascondi="nascondiWorkOrder"
      @click_note_commessa="handleNoteCommessa"
      @click_note_fase="handleNoteFase"
      @click_note_fase_precedente="handleNoteFasePrecedente"
      @click_prelievi="clickPrelievi"
      @click_questionario_qualita="handleClickQuestionarioQualita"
      @click_registra_fermi="clickRegistraFermi"
      @click_registra_imballi="handleClickRegistraImballi"
      @click_registra_pezzi="clickRegistraPezzi"
      @click_registra_pezzi_alternativi="clickRegistraPezziAlternativi"
      @click_registra_pezzi_seriali="clickRegistraPezziSeriali"
      @click_registra_scarti="clickRegistraScarti"
      @click_registra_cont_alternativi="clickRegistraContAlternativi"
      @click_ristampa_seriale="clickRistampaSeriale"
      @click_scheda_packaging="handleSchedaPackaging"
      @click_scheda_richieste="handleSchedaRichieste"
      @click_segnalazione="handleClickSegnalazione"
      @click_start="clickStart"
      @click_stop="clickStop"
      @click_subentro="clickSubentro"
      @click_visualizza_allegto_controllo="clickVisualizzaAllegatoControllo"
      @click_visualizza_disegno="clickVisualizzaDisegno"
      @config_avvio_multiplo_wo="handleConfigAvvioMultiploWo"
      @column_is_mounted="setSwitchStartStop"
      @id_header_query="handleIdHeaderQuery"
      :handleClickCheck="handleClickCheck"
      :items_carrello="work_orders_in_corso"
      ref="CarrelloLayout"
      :rotta_back="rotta_back"
      style="width: 100%"
    />
    <v-dialog v-model="dialog_Richieste" width="unset">
      <Richieste @dialogClose="dialogClose" :hideInterventoButtom="true" />
    </v-dialog>

    <!-- Dialog del consuntivo dei work order -->
    <!--<v-dialog v-model="consuntivo_commesse_visible">-->
    <!-- <ConsuntivoWorkOrder
        :avvio_multiplo_enabled="avvio_multiplo_enabled"
        @click_chiudi="consuntivo_commesse_visible = false"
        @inviato_elemento="consuntivo_commesse_visible = false"
        :items_consuntivo="work_orders_totali"
        v-if="consuntivo_commesse_visible == true"
        :visible="consuntivo_commesse_visible"
      /> -->
    <WorkorderLayout
      :avvio_multiplo_enabled="avvio_multiplo_enabled"
      @click_chiudi="consuntivo_commesse_visible = false"
      @inviato_elemento="consuntivo_commesse_visible = false"
      :items_consuntivo="work_orders_totali"
      v-if="consuntivo_commesse_visible == true"
      :visible="consuntivo_commesse_visible"
    />
    <!--</v-dialog>-->

    <!-- Dialog del consuntivo delle macchine multicommessa -->
    <v-dialog v-model="macchine_multi_visible">
      <ConsuntivoMacchineMulti
        :items_macchine_multi="items_macchine_multi"
        :visible="macchine_multi_visible"
        @click_chiudi="macchine_multi_visible = false"
        @selezionata_macchina="handleSelezionataMacchina"
        v-if="macchine_multi_visible === true"
      />
    </v-dialog>

    <!-- Dialog del consuntivo dei work order per la multicommessa -->
    <v-dialog v-model="consuntivo_wo_multi_visible">
      <ConsuntivoWorkOrderMulti
        :items_wo_multi="items_wo_multi"
        :visible="consuntivo_wo_multi_visible"
        @click_chiudi="consuntivo_wo_multi_visible = false"
        @selezionati_wo="handleSelezionatiWO"
        v-if="consuntivo_wo_multi_visible === true"
      />
    </v-dialog>

    <!-- Dialog di registrazione pezzi -->
    <v-dialog v-model="registra_pezzi_visible">
      <RegistraPezzi
        @click_avanti="handleClickAvantiRegistraPezzi"
        @click_indietro="handleClickBackRegPz"
        @click_salva="handleSalvaRegistraPezzi()"
        :flag_em_registrazione="filtroEM === '1' ? filtroEM : ''"
        :id_header_query="id_header_query"
        :visible="registra_pezzi_visible"
        @work_order_completato="handleWorkOrderCompletato()"
        :work_order_sel="work_order_sel"
        :work_order_sempre_aperto="work_order_sempre_aperto"
      />
    </v-dialog>

    <!-- Dialog di registrazione elementi -->
    <v-dialog v-model="registra_elementi_visible" width="700px">
      <RegistraElementi
        @click_indietro="handleClickBackRegPz"
        @click_salva="handleSalvaRegistraElementi()"
        :visible="registra_elementi_visible"
        :work_order_sel="work_order_sel"
      />
    </v-dialog>

    <!-- Dialog di registrazione degli scarti -->
    <v-dialog v-model="registra_scarti_visible">
      <RegistraScarti
        @click_indietro="handleClickBackRegScarti"
        @click_salva="handleSalvaRegistraScarti()"
        :visible="registra_scarti_visible"
        :work_order_sel="work_order_sel"
      />
    </v-dialog>

    <!-- Dialog di registrazione dei fermi -->
    <v-dialog v-model="registra_fermi_visible">
      <RegistraFermi
        @click_indietro="handleClickBackRegFermi"
        @click_salva="handleSalvaRegistraFermi()"
        :visible="registra_fermi_visible"
        :work_order_sel="work_order_sel"
      />
    </v-dialog>

    <!-- Dialog di registrazione dei pezzi alternativi -->
    <v-dialog v-model="registra_pezzi_alternativi_visible">
      <RegistraPezziAlt
        @click_indietro="handleClickBackRegPzAlt"
        @click_salva="handleSalvaRegistraPezziAlt()"
        :flag_em_registrazione="filtroEM === '1' ? filtroEM : ''"
        :id_header_query="id_header_query"
        :visible="registra_pezzi_alternativi_visible"
        @work_order_completato="handleWorkOrderAltCompletato()"
        :work_order_sel="work_order_sel"
      />
    </v-dialog>

    <!-- Dialog di registrazione dei pezzi seriali -->
    <v-dialog v-model="registra_pezzi_seriali_visible" width="90vw">
      <RegistraPezziSeriali
        v-if="registra_pezzi_seriali_visible"
        @click_indietro="handleClickBackRegPzSeriali"
        @click_salva="handleSalvaRegistraPezziSeriali"
        :id_header_query="id_header_query"
        :visible="registra_pezzi_seriali_visible"
        @work_order_completato="handleWOSerialeCompletato"
        :work_order_sel="work_order_sel"
        :work_order_sempre_aperto="work_order_sempre_aperto"
      />
    </v-dialog>

    <v-dialog v-model="registra_pezzi_multi_visible">
      <RegistraPezziMulti
        @click_indietro="
          registra_pezzi_multi_visible = !registra_pezzi_multi_visible
        "
        :items_wo_multi_reg_pezzi="items_wo_multi_reg_pezzi"
        :key="key_registra_pezzi_multi"
        @registrati_pezzi="
          getWorkOrdersUtente();
          registra_pezzi_multi_visible = false;
        "
        :visible="registra_pezzi_multi_visible"
      />
    </v-dialog>

    <v-dialog persistent v-model="registra_tempi_visible">
      <RegistraTempi
        @click_salva="handleClickAvantiRegistraTempi()"
        @click_indietro="handleClickIndietroRegistraTempi()"
        :id_header_query="id_header_query"
        ref="registra_tempi"
        :visible="registra_tempi_visible"
        :work_order_sel="work_order_sel"
      />
    </v-dialog>

    <v-dialog persistent v-model="visualizza_disegno_visible">
      <VisualizzaDisegno
        @click_chiudi="validaDisegno"
        :visible="visualizza_disegno_visible"
        :work_order_sel="work_order_sel"
      />
    </v-dialog>

    <v-dialog persistent v-model="allegato_controllo_visible" width="unset">
      <GestioneAllegato
        @click_chiudi="allegato_controllo_visible = false"
        :consenti_upload="false"
        controller_allegati="Global"
        controller_caratteristiche_tabella="Manutenzione"
        :id_riferimento="
          work_order_sel != null ? work_order_sel.id_ciclo_fasi : null
        "
        ref="componenteAllegati"
        @snackbarOpen="snackbarOpen"
        tipo_allegato="CONTROLLO"
        :tipo_headers="'minimi'"
      />
    </v-dialog>

    <v-dialog persistent v-model="subentro_visible" width="unset">
      <Subentro
        @click_chiudi="handleCloseSubentro"
        @credenziali_inviate="handleCredInv"
        :work_order_sel="work_order_sel"
      />
    </v-dialog>

    <v-dialog persistent v-model="avanza_confezioni_visible" width="unset">
      <AvanzaConfezioni
        :opzioni_quantita_alternativa="
          opzioni_quantita_alternativa.filter((e) => e.predefinito != 1)
        "
        :pkg_std="pkg_std"
        :workorder="work_order_sel"
        @click_chiudi="handleCloseAvanzaConfezioni"
        @registrato_qrcode="handleRegistratoQrCode"
      />
    </v-dialog>

    <v-dialog persistent v-model="avanza_contenitore_visible" width="unset">
      <AvanzaContenitore
        :opzioni_quantita_alternativa="
          opzioni_quantita_alternativa.filter((e) => e.predefinito != 1)
        "
        :pkg_std="pkg_std"
        :workorder="work_order_sel"
        @click_chiudi="handleCloseAvanzaContenitore"
        @registrato_qrcode="handleRegistratoQrCode"
      />
    </v-dialog>

    <!-- Avanzamento contenitori di Sicily Food -->
    <v-dialog persistent v-model="avanza_contenitore_sf_visible" width="unset">
      <AvanzaContenitoreSF
        :opzioni_quantita_alternativa="
          opzioni_quantita_alternativa.filter((e) => e.predefinito != 1)
        "
        :pkg_std="pkg_std"
        :workorder="work_order_sel"
        @click_chiudi="handleCloseAvanzaContenitoreSF"
        @registrato_qrcode="handleRegistratoQrCode"
      />
    </v-dialog>

    <!-- Dialog di registrazione dei conetnitori alternativi -->
    <v-dialog
      persistent
      v-model="registra_cont_alternativi_visible"
      width="unset"
    >
      <AvanzaContenitoreAlt
        @click_chiudi="handleClickBackRegContAlt"
        @click_salva="handleSalvaRegistraContAlt()"
        :registrazione_alternativa="1"
        :visible="registra_cont_alternativi_visible"
        :workorder="work_order_sel"
      />
    </v-dialog>

    <!-- Dialog della gestione prelievi -->
    <v-dialog persistent v-model="prelievi_visible" width="90vw">
      <Prelievi
        @aggiorna_work_orders="handleUpdatePrelievi"
        @click_chiudi="handleClickChiudiPrelievi"
        @click_prosegui="handleClickChiudiProseguiPrelievi"
        :fase_sel="work_order_sel"
        :picking_allowed="picking_allowed"
        :visibile="prelievi_visible"
        :modulo_chiamante="'AVANZAMENTO'"
      />
    </v-dialog>

    <!-- Dialog delle note della fase -->
    <v-dialog v-model="dialog_note_fase" width="500px">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">Note Fase</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="closeNoteFase" small v-bind="attrs" v-on="on"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text style="overflow-y: auto">
          <v-textarea v-model="work_order_sel.note_fase"></v-textarea>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog delle note della fase precedente -->
    <v-dialog v-model="dialog_note_fase_custom" width="500px">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">Note Fase</v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="saveNoteFase" small v-bind="attrs" v-on="on">
                <v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="closeNoteFasePrecedente"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text style="overflow-y: auto">
          <v-container class="mt-5" fluid>
            <v-row align="center" dense justify="center">
              <v-col cols="12">
                <v-textarea
                  dense
                  label="Note Fasi Precedenti"
                  outlined
                  :rows="2"
                  style="border-radius: 0px"
                  v-model="work_order_sel.note_fase_custom"
                >
                </v-textarea>
              </v-col>
            </v-row>
            <v-row align="center" dense justify="center">
              <v-col cols="12">
                <v-textarea
                  dense
                  label="Nota Fase Attuale"
                  outlined
                  :rows="2"
                  style="border-radius: 0px"
                  v-model="work_order_sel.note_fase"
                >
                </v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog delle note della commessa -->
    <v-dialog v-model="dialog_note_commessa" width="500px">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">Note Commessa</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="closeNoteCommessa" small v-bind="attrs" v-on="on">
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="pt-5" style="overflow-y: auto">
          <v-textarea
            outlined
            style="border-radius: 0px"
            v-model="work_order_sel.note_commessa"
          ></v-textarea>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di controllo qualità -->
    <v-dialog persistent v-model="controllo_qualita_visible" width="90vw">
      <ControlloQualita
        @click_chiudi="handleCloseContQual"
        @eseguito_controllo="handleRegInv(true)"
        :headers_controllo="headers_controllo"
        :key="controllo_qualita_visible === true ? 1 : 0"
        :tipo_operazione="'CONTROLLO'"
        :visible="controllo_qualita_visible"
        :work_order_sel="work_order_sel"
      />
    </v-dialog>

    <!-- Dialog di campionatura -->
    <v-dialog persistent v-model="campionatura_visible" width="90vw">
      <ControlloQualita
        @click_chiudi="handleCloseContQual"
        @eseguito_controllo="handleRegCampionatura"
        :headers_controllo="headers_campionatura"
        :key="campionatura_visible === true ? 1 : 0"
        :tipo_operazione="'CAMPIONATURA'"
        :visible="campionatura_visible"
        :work_order_sel="work_order_sel"
      />
    </v-dialog>

    <!-- Dialog di controllo inizio lotto -->
    <v-dialog persistent v-model="controllo_qualita_mp_visible" width="90vw">
      <ControlloQualita
        @click_chiudi="handleCloseContQual"
        @eseguito_controllo="handleRegInv(true)"
        :headers_controllo="headers_controllo_mp"
        :key="controllo_qualita_visible === true ? 1 : 0"
        :tipo_operazione="'CONTROLLOMP'"
        :visible="controllo_qualita_mp_visible"
        :work_order_sel="work_order_sel"
      />
    </v-dialog>

    <!-- Dialog di controllo chiusura fase -->
    <v-dialog persistent v-model="controllo_qualita_chiusura_fase" width="90vw">
      <ControlloQualita
        @click_chiudi="handleCloseContQual"
        @eseguito_controllo="
          handleRegInv(false);
          chiusuraFase();
        "
        :headers_controllo="headers_controllo"
        :key="controllo_qualita_visible === true ? 1 : 0"
        :tipo_operazione="'CONTROLLO'"
        :visible="controllo_qualita_chiusura_fase"
        :work_order_sel="work_order_sel"
      />
    </v-dialog>

    <v-dialog v-model="gestione_allegati_visible">
      <v-card>
        <GestioneAllegato
          @click_chiudi="
            gestione_allegati_visible = false;
            performPopQuery(createStdQueryArr(work_order_sel));
          "
          controller_allegati="Global"
          controller_caratteristiche_tabella="Magazzino"
          :id_riferimento="work_order_sel.id_ciclo_fasi"
          :key="key_allegati"
          :read_only="true"
          ref="componenteAllegati"
          :show_close="true"
          :show_save_button="false"
          @snackbarOpen="snackbarOpen"
          tipo_allegato="CONTROLLO"
          :tipo_headers="'minimi'"
          :toolbar_title="'Documenti Associati'"
        />
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_app_loghi" fullscreen>
      <v-card
        class="ma-0 pa-0"
        height="calc(100vh - 100px)"
        style="overflow: hidden"
      >
        <div style="position: relative; height: 100%; overflow-y: hidden">
          <WindowFrame
            class="ma-0 pa-0"
            :component="'imageprod'"
            ref="windowframe_idearicamo"
            @chiudi="closeAppLoghi"
            :input_args="input_args"
            :key="key_idearicamo"
          />
        </div>
        <!-- <div style="position: relative; height: 100%; overflow-y: hidden">
          <WindowFrame
            class="ma-0 pa-0"
            :component="'imageprod'"
            ref="windowframe_idearicamo"
            @chiudi="closeAppLoghi"
            :input_args="input_args"
            :key="key_idearicamo"
          />
        </div> -->
      </v-card>
    </v-dialog>

    <!-- Componente per mettere a disposizione i metodi del Packaging -->
    <div v-show="false">
      <Packaging2
        @chiuso_dettaglio_dialog="handleClosedDettaglioPackaging"
        @salvato_dettaglio_dialog="handleSavedDettaglioPackaging"
        :data="articolo_per_packaging"
        :quicklabel_allowed="quicklabel_allowed"
        ref="packaging2"
      />
    </div>

    <!-- Componente per mettere a disposizione i metodi del della colonna,
         in particolare la funzione di setCommessaTempi per lo start automatico. -->
    <div v-show="false">
      <ProduzioneLayoutColumn
        ref="ProduzioneLayoutColumn"
      ></ProduzioneLayoutColumn>
    </div>

    <div
      style="
        background-color: rgba(33, 33, 33, 0.46);
        bottom: 0;
        height: 100%;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        width: 100%;
        z-index: 2;
      "
      v-if="controllo_dialog_visible"
    >
      <div
        style="height: 90%; left: 5%; position: absolute; top: 5%; width: 90%"
      >
        <Controllo
          @click_indietro="controllo_dialog_visible = false"
          :id_causale_sel="id_causale_sel"
        />
      </div>
    </div>

    <!-- Dialog della history del WO -->
    <v-dialog v-model="history_dialog">
      <HistoryDialogWO
        @click_indietro="history_dialog = false"
        :visible="history_dialog"
        :work_order_sel="work_order_sel"
      />
    </v-dialog>

    <!-- Dialog del lavoro squadra -->
    <v-dialog v-model="lavoro_squadra_visible" width="90%">
      <LavoroSquadra
        @click_chiudi="handleCloseLavoroSquadra"
        @salvato_lavoro="handleSalvatoLavoro"
        :visible="lavoro_squadra_visible"
        :work_order_sel="work_order_sel"
      />
    </v-dialog>

    <!-- Dialog della registrazione imballi -->
    <v-dialog v-model="dialog_registrazione_imballi" width="75vw" persistent>
      <StampaEtichetteComponent
        @chiudi="closeRegistrazioneImballi"
        @registrazione_avvenuta="handleRegAvvImballi"
        :visible="dialog_registrazione_imballi"
        :workorder="work_order_sel"
      />
    </v-dialog>

    <!-- Dialog della registrazione imballi -->
    <v-dialog v-model="ristampa_seriale_visible" width="75vw" persistent>
      <RistampaSeriali
        @chiudi="ristampa_seriale_visible = false"
        :v-if="ristampa_seriale_visible"
        :workorder="work_order_sel"
      />
    </v-dialog>

    <!-- Dialog della registrazione imballi -->
    <v-dialog v-model="dialog_report_seriali" width="60vw" persistent>
      <StampaReportSeriali
        @chiudi="dialog_report_seriali = false"
        :seriali="items_seriali"
        :visible="dialog_report_seriali"
        :workorder="work_order_sel"
      />
    </v-dialog>

    <!-- Dialog del Window Frame degli allegati -->
    <v-dialog class="ma-0 pa-0" v-model="window_frame_allegati_visible">
      <v-card
        class="ma-0 pa-0"
        height="calc(100vh - 100px)"
        style="overflow: hidden"
      >
        <div style="position: relative; height: 100%">
          <WindowFrame
            class="ma-0 pa-0"
            @click_chiudi="closeWindowFrame"
            :component="'allegati'"
            @fine_sessione_check="handleFineSessioneCheck"
            :input_args="input_args"
            :key="key_window_frame"
            ref="windowframe_allegati"
            @salvati_disegni="handleSalvatiDisegni"
          />
        </div>
      </v-card>
    </v-dialog>

    <!-- Dialog del Window Frame di QM -->
    <v-dialog class="ma-0 pa-0" v-model="window_frame_qm_visible">
      <v-card
        class="ma-0 pa-0"
        height="calc(100vh - 100px)"
        style="overflow: hidden"
      >
        <div style="position: relative; height: 100%">
          <WindowFrame
            class="ma-0 pa-0"
            @click_chiudi="closeWindowFrame"
            :component="'qm'"
            @fine_sessione_check="handleFineSessioneCheck"
            :input_args="input_args"
            :key="key_window_frame"
            ref="windowframe_qm"
            @salvati_disegni="handleSalvatiDisegni"
          />
        </div>
      </v-card>
    </v-dialog>

    <!-- Dialog del Window Frame delle Segnalazioni -->
    <v-dialog class="ma-0 pa-0" v-model="window_frame_segnalazioni_visible">
      <v-card
        class="ma-0 pa-0"
        height="calc(100vh - 100px)"
        style="overflow: hidden"
      >
        <div style="position: relative; height: 100%">
          <WindowFrame
            class="ma-0 pa-0"
            @click_chiudi="closeWindowFrame"
            :component="'anomalie'"
            @fine_sessione_check="handleFineSessioneCheck"
            :input_args="input_args"
            :key="key_window_frame"
            @loaded="handleAnomalieLoaded()"
            ref="windowframe_segnalazioni"
            @salvati_disegni="handleSalvatiDisegniSegnalazione"
          />
        </div>
      </v-card>
    </v-dialog>

    <!-- Dialog del Window Frame di QuickCheck -->
    <v-dialog class="ma-0 pa-0" v-model="window_frame_check_visible">
      <v-card
        class="ma-0 pa-0"
        height="calc(100vh - 100px)"
        style="overflow: hidden"
      >
        <div style="position: relative; height: 100%">
          <WindowFrame
            class="ma-0 pa-0"
            @click_chiudi="closeWindowFrame"
            :component="component_window_frame"
            @fine_sessione_check="handleFineSessioneCheck"
            :input_args="input_args"
            :key="key_window_frame"
            @loaded="handleCheckLoaded()"
            ref="windowframe_check"
            @salvati_disegni="handleSalvatiDisegni"
          />
        </div>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma esecuzione QuickCheck -->
    <v-dialog v-model="conferma_check_visible" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Questionario </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            È stato rilevato un questionario non completato, vuoi terminarlo?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn class="mr-5" @click="noConfermaEseguiCheck()" small>
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn @click="confermaEseguiCheck(getrelazioni)" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di di registrazione dell'articolo residuo -->
    <v-dialog v-model="dialog_registra_art_res" width="unset">
      <RegistraArtRes
        @click_chiudi="dialog_registra_art_res = false"
        :key="key_registra_art_res"
        :work_order_sel="work_order_sel"
        @salvatiArticoliResidui="handleSalvatiArticoliResidui"
      />
    </v-dialog>

    <!-- Dialog di conferma esecuzione QuickCheck -->
    <v-dialog v-model="questionario_qualita_visible">
      <v-card
        class="ma-0 pa-0"
        height="calc(100vh - 100px)"
        style="overflow: hidden"
      >
        <div style="position: relative; height: 100%">
          <QuestionarioQualita
            @click_chiudi="chiudiQuestionarioQualita"
            @fine_sessione_check="handleFineQuestionarioQualita"
            :props_questionario_qualita="props_questionario_qualita"
            :visible="questionario_qualita_visible"
            :work_order_sel="work_order_sel"
            :key="key_questionario_qualita"
            style="height: 100%"
          />
        </div>
      </v-card>
    </v-dialog>

    <!-- Dialog di registrazione del peso di Sicily Food -->
    <v-dialog
      persistent
      :key="key_dialog_registra_peso"
      v-model="dialog_registra_peso"
      width="700"
    >
      <RegistraPeso
        :work_order="work_order_sel"
        @chiudiRegistraPeso="dialog_registra_peso = false"
        @registraFase="handleRegistraFaseCarrello"
      />
    </v-dialog>

    <!-- Dialog di chiusura massiva delle fasi -->
    <v-dialog persistent v-model="dialog_chiusura_massiva_fasi" width="91vw">
      <ChiusuraMassivaFasi
        :key="key_dialog_chiusura_massiva_fasi"
        :work_order="work_order_sel"
        @annulla_chiudi_wo_mass="dialog_chiusura_massiva_fasi = false"
        @registrate_fasi_commessa="handleRegistrateFasiCommessa"
      />
    </v-dialog>

    <!-- Dialog di visualizzazione etichette -->
    <v-dialog v-model="dialog_risme_etichette" max-width="600">
      <v-card>
        <!-- Toolbar del dialog -->
        <v-toolbar dense color="indigo">
          <v-toolbar-title class="white--text">
            Etichette Generate
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_risme_etichette = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5">
          <v-row align="center" justify="center">
            <v-col cols="4" v-for="(elem, i) in items_risme_etichette" :key="i">
              <!-- Sezione della miniatura + cod_report -->
              <div>
                <!-- Sezione della miniatura -->
                <div>
                  <v-icon
                    @click="showPdfViewer(elem)"
                    color="error"
                    x-large
                    style="font-size: 100px"
                  >
                    mdi-file-pdf-box
                  </v-icon>
                </div>
                <!-- Sezione del cod_report -->
                <div>
                  <span>
                    <b>{{ elem.titolo }}</b>
                  </span>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di visualizzazione etichette -->
    <v-dialog v-model="dialog_preview" width="unset">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Stampa Etichetta
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="chiudiDialogPreview"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-col cols="12">
          <iframe
            :src="iframeUrl"
            frameborder="0"
            style="height: 70vh !important; width: 750px !important"
          >
          </iframe>
        </v-col>
      </v-card>
    </v-dialog>

    <!-- Dialog di scelta commessa da aprire per gli allegati -->
    <v-dialog v-model="dialog_scelta_fase_allegati" persistent width="unset">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Scelta Commessa
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_scelta_fase_allegati = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-col cols="12">
          <v-data-table
            :headers="headers_fasi_selezionabili_allegati"
            :items="items_fasi_selezionabili_allegati"
          >
            <template v-slot:[`item.selezione`]="{ item }">
              <v-btn
                @click="selezionaCommessaAllegati(item)"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success"> mdi-check </v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-card>
    </v-dialog>

    <!-- Dialog del Window Frame di QuickCheck -->
    <v-dialog v-model="dialog_riapertura_master" persistent width="700px">
      <RiaperturaMaster
        @click_chiudi="dialog_riapertura_master = false"
        @riapertura_master="handleRiaperturaMaster"
        :work_order="work_order_sel"
        v-if="dialog_riapertura_master"
      />
    </v-dialog>

    <v-overlay :value="caricamento_dati">
      <v-icon class="ruota" size="100">mdi-cog</v-icon>
      <v-icon class="controruota" size="100">mdi-cogs</v-icon>
    </v-overlay>

    <!-- Multi-Snackbar -->
    <MultiSnackbarQV ref="MultiSnackbarQV" />

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>

<script>
import WorkorderLayout from "@/views/PRODUCTION/WorkorderLayout/WorkorderLayout.vue";
import AvanzaConfezioni from "@/components/PRODUCTION/ProduzioneInsit/AvanzaConfezioni.vue";
import AvanzaContenitore from "@/components/PRODUCTION/ProduzioneInsit/AvanzaContenitore.vue";
import AvanzaContenitoreAlt from "@/components/PRODUCTION/ProduzioneInsit/AvanzaContenitoreAlt.vue";
import AvanzaContenitoreSF from "@/components/PRODUCTION/ProduzioneInsit/AvanzaContenitoreSF.vue";
import CarrelloLayout from "@/components/PRODUCTION/ProduzioneLayout/CarrelloLayout.vue";
import ChiusuraMassivaFasi from "@/components/PRODUCTION/ProduzioneDistintaAvanzamento/ChiusuraMassivaFasi.vue";
import ConsuntivoMacchineMulti from "@/components/PRODUCTION/ProduzioneInsit/ConsuntivoMacchineMulti.vue";
// import ConsuntivoWorkOrder from "@/components/PRODUCTION/ProduzioneInsit/ConsuntivoWorkOrder.vue";
import ConsuntivoWorkOrderMulti from "@/components/PRODUCTION/ProduzioneInsit/ConsuntivoWorkOrderMulti.vue";
import Controllo from "@/views/PRODUCTION/Controllo/Controllo.vue";
import ControlloQualita from "@/components/PRODUCTION/Produzione/ControlloQualita.vue";
import GestioneAllegato from "@/components/TOOLS/GestioneAllegato.vue";
import HistoryDialogWO from "@/components/PRODUCTION/ProduzioneInsit/HistoryDialogWO.vue";
import LavoroSquadra from "@/components/PRODUCTION/ProduzioneInsit/LavoroSquadra.vue";
import moment from "moment/moment";
import MultiSnackbarQV from "@/components/TOOLS/MultiSnackbarQV.vue";
import Packaging2 from "@/views/PRODUCTION/Articolo/ArticoloDrawer/Packaging2.vue";
import Prelievi from "@/components/PRODUCTION/Produzione/Prelievi.vue";
import ProduzioneLayoutColumn from "@/components/PRODUCTION/ProduzioneLayout/ProduzioneLayoutColumn.vue";
import QuestionarioQualita from "@/components/PRODUCTION/ProduzioneLayout/QuestionarioQualita.vue";
import RegistraElementi from "@/components/PRODUCTION/ProduzioneInsit/RegistraElementi.vue";
import RegistraPeso from "@/components/PRODUCTION/ProduzioneLayout/RegistraPeso.vue";
import RegistraPezzi from "@/components/PRODUCTION/ProduzioneInsit/RegistraPezzi.vue";
import RegistraPezziAlt from "@/components/PRODUCTION/ProduzioneInsit/RegistraPezziAlt.vue";
import RegistraPezziSeriali from "@/components/PRODUCTION/ProduzioneInsit/RegistraPezziSeriali.vue";
import RegistraArtRes from "@/components/PRODUCTION/ProduzioneInsit/RegistraArtRes.vue";
import RegistraFermi from "@/components/PRODUCTION/ProduzioneInsit/RegistraFermi.vue";
import RegistraPezziMulti from "@/components/PRODUCTION/ProduzioneInsit/RegistraPezziMulti.vue";
import RegistraScarti from "@/components/PRODUCTION/ProduzioneInsit/RegistraScarti.vue";
import RegistraTempi from "@/components/PRODUCTION/ProduzioneInsit/RegistraTempi.vue";
import RiaperturaMaster from "@/components/PRODUCTION/ProduzioneInsit/RiaperturaMaster";
import Richieste from "@/components/QUICKMANUTENZIONE/Richieste/Richiesta";
import RistampaSeriali from "@/components/PRODUCTION/ProduzioneInsit/RistampaSeriali";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import StampaEtichetteComponent from "@/components/PRODUCTION/ProduzioneInsit/StampaEtichetteComponent.vue";
import StampaReportSeriali from "@/components/PRODUCTION/ProduzioneInsit/StampaReportSeriali.vue";
import Subentro from "@/components/PRODUCTION/Produzione/Subentro.vue";
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";
import VisualizzaDisegno from "@/components/PRODUCTION/ProduzioneInsit/VisualizzaDisegno.vue";

export default {
  name: "ProduzioneLayout",
  components: {
    WorkorderLayout,
    AvanzaConfezioni,
    AvanzaContenitore,
    AvanzaContenitoreAlt,
    AvanzaContenitoreSF,
    CarrelloLayout,
    ChiusuraMassivaFasi,
    ConsuntivoMacchineMulti,
    // ConsuntivoWorkOrder,
    ConsuntivoWorkOrderMulti,
    Controllo,
    ControlloQualita,
    GestioneAllegato,
    HistoryDialogWO,
    LavoroSquadra,
    MultiSnackbarQV,
    Packaging2,
    Prelievi,
    ProduzioneLayoutColumn,
    QuestionarioQualita,
    RegistraArtRes,
    RegistraElementi,
    RegistraFermi,
    RegistraPeso,
    RegistraPezzi,
    RegistraPezziAlt,
    RegistraPezziMulti,
    RegistraPezziSeriali,
    RegistraScarti,
    RegistraTempi,
    RiaperturaMaster,
    Richieste,
    RistampaSeriali,
    SnackbarQV,
    StampaEtichetteComponent,
    StampaReportSeriali,
    Subentro,
    VisualizzaDisegno,
    WindowFrame,
  },
  props: {
    back_as_landing_page: {
      type: Boolean,
      default: true,
    },
    cod_commessa: {
      type: String,
      default: "",
    },
    commessa: {
      type: Object,
      default: () => {},
    },
    filtroEM: {
      type: String,
      default: "",
    },
    open_consuntivi_if_empty: {
      type: Boolean,
      default: false,
    },
    rotta_back: { type: String, default: "/home/production" },
    visible: {
      type: Boolean,
      default: true,
    },
    work_order_sempre_aperto: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      articolo_per_packaging: { id_articolo: null },
      caricamento_dati: false,
      component_window_frame: "",
      getrelazioni: null,
      id_causale_sel: null,
      id_header_query: null,
      iframeUrl: "",
      input_args: {
        toolbar_visible: false,
        dizionario: new Object(),
        esterno: 1,
      },
      interval: null,
      intervallo_work_orders: 0,
      key_allegati: 0,
      key_dialog_chiusura_massiva_fasi: 0,
      key_dialog_registra_peso: 0,
      key_idearicamo: 0,
      key_questionario_qualita: 0,
      key_registra_art_res: 0,
      key_registra_pezzi_multi: 0,
      key_window_frame: 0,
      landing_page_check: "quiz_detail",
      nascondi_WO: false,
      picking_allowed: 1,
      pkg_std: new Object(),
      props_questionario_qualita: new Object(),
      quest_app_exec_ok: false,
      quicklabel_allowed: 0,
      set_start_happened: false,
      sse_src: null,
      start_automatico: 0,
      work_order_sel: new Object(),

      // Modal
      allegato_controllo_visible: false,
      avanza_confezioni_visible: false,
      avanza_contenitore_visible: false,
      avanza_contenitore_sf_visible: false,
      avvio_multiplo_enabled: 0,
      campionatura_visible: false,
      conferma_check_visible: false,
      consuntivo_commesse_visible: false,
      consuntivo_wo_multi_visible: false,
      controllo_dialog_visible: false,
      controllo_qualita_chiusura_fase: false,
      controllo_qualita_mp_visible: false,
      controllo_qualita_visible: false,
      dialog_app_loghi: false,
      dialog_chiusura_massiva_fasi: false,
      registra_elementi_visible: false,
      dialog_preview: false,
      dialog_registra_art_res: false,
      dialog_registra_peso: false,
      dialog_report_seriali: false,
      dialog_riapertura_master: false,
      dialog_Richieste: false,
      dialog_risme_etichette: false,
      dialog_scelta_fase_allegati: false,
      dialog_note_commessa: false,
      dialog_note_fase: false,
      dialog_note_fase_custom: false,
      dialog_registrazione_imballi: false,
      gestione_allegati_visible: false,
      history_dialog: false,
      lavoro_squadra_visible: false,
      macchine_multi_visible: false,
      prelievi_visible: false,
      questionario_qualita_visible: false,
      registra_cont_alternativi_visible: false,
      registra_fermi_visible: false,
      registra_pezzi_visible: false,
      registra_pezzi_alternativi_visible: false,
      registra_pezzi_multi_visible: false,
      registra_pezzi_seriali_visible: false,
      registra_scarti_visible: false,
      registra_tempi_visible: false,
      ristampa_seriale_visible: false,
      subentro_visible: false,
      subentro_waiting: false,
      visualizza_disegno_visible: false,
      window_frame_allegati_visible: false,
      window_frame_segnalazioni_visible: false,
      window_frame_check_visible: false,
      window_frame_qm_visible: false,

      // Array
      headers_campionatura: [
        {
          text: "Num. Riga",
          sortable: false,
          value: "num_riga",
        },
        {
          text: "Des. Caratteristica",
          sortable: false,
          value: "des_caratteristica",
        },
        { text: "Frequenza", sortable: false, value: "frequenza" },
        { text: "Valore Min.", sortable: false, value: "valore_min" },
        { text: "Valore", sortable: false, value: "valore" },
        { text: "Valore Max.", sortable: false, value: "valore_max" },
        { text: "Tolleranza", sortable: false, value: "tolleranza" },
        { text: "Des. Strumento", sortable: false, value: "des_strumento" },
        { text: "Note", sortable: false, value: "note" },
        { text: "Misura", sortable: false, value: "misura" },
      ],
      headers_controllo: [
        {
          text: "Num. Riga",
          sortable: false,
          value: "num_riga",
        },
        {
          text: "Des. Caratteristica",
          sortable: false,
          value: "des_caratteristica",
        },
        { text: "Frequenza", sortable: false, value: "frequenza" },
        { text: "Valore Min.", sortable: false, value: "valore_min" },
        { text: "Valore", sortable: false, value: "valore" },
        { text: "Valore Max.", sortable: false, value: "valore_max" },
        { text: "Tolleranza", sortable: false, value: "tolleranza" },
        { text: "Des. Strumento", sortable: false, value: "des_strumento" },
        { text: "Note", sortable: false, value: "note" },
        { text: "Misura", sortable: false, value: "misura" },
      ],
      headers_controllo_mp: [
        {
          text: "Num. Riga",
          sortable: false,
          value: "num_riga",
        },
        {
          text: "Cod. Articolo",
          sortable: false,
          value: "cod_articolo",
        },
        {
          text: "Cod. Lotto",
          sortable: false,
          value: "cod_lotto",
        },
        {
          text: "Des. Caratteristica",
          sortable: false,
          value: "des_caratteristica",
        },
        { text: "Frequenza", sortable: false, value: "frequenza" },
        { text: "Valore Min.", sortable: false, value: "valore_min" },
        { text: "Valore", sortable: false, value: "valore" },
        { text: "Valore Max.", sortable: false, value: "valore_max" },
        { text: "Tolleranza", sortable: false, value: "tolleranza" },
        { text: "Des. Strumento", sortable: false, value: "des_strumento" },
        { text: "Note", sortable: false, value: "note" },
        { text: "Misura", sortable: false, value: "misura" },
      ],
      headers_fasi_selezionabili_allegati: [
        {
          text: "Selezione",
          sortable: false,
          value: "selezione",
        },
        { text: "Rif. Ordine", sortable: false, value: "cod_documento" },
        { text: "Cod. Commessa", sortable: false, value: "cod_commessa" },
      ],
      items_fasi_selezionabili_allegati: new Array(),
      items_risme_etichette: new Array(),
      items_seriali: new Array(),
      items_wo_multi: [],
      items_wo_multi_reg_pezzi: [],
      items_macchine_multi: [],
      work_orders_in_corso: [],
      work_orders_totali: [],
      opzioni_quantita_alternativa: [],
      stack_check: new Array(),
    };
  },
  watch: {
    visible: {
      immediate: true,
      async handler() {
        if (this.visible === true) {
          // Popolo la lista delle macchine
          this.getListaMacchine();

          // Popolo l'array dei work order già presi in carico.
          await this.getWorkOrdersUtente();

          // Controllo se l'utente deve eseguire un controllo di qualità.
          // this.checkControlloQualita();

          /* Se sono non ci sono WO in corso e la prop me
           * lo consente, apro il dialog dei consuntivi per
           * scegliere dei WO da aggiungere al carrello. */
          if (
            this.work_orders_in_corso.length === 0 &&
            this.open_consuntivi_if_empty === true
          ) {
            this.$refs.CarrelloLayout.clickAggiungi();
          }
        }
      },
    },
  },
  methods: {
    handleClickAllegatiCommessa(arg) {
      // Controllo di avere un gruppo di fasi.
      if (
        this.work_order_sel.dati_commessa_gruppo_fasi != undefined &&
        this.work_order_sel.dati_commessa_gruppo_fasi.indexOf("|") != -1
      ) {
        const arr_gruppo_fasi =
          this.work_order_sel.dati_commessa_gruppo_fasi.split(";");

        /* Se ho un gruppo con una sola fase,
         * apro gli allegati di quella fase. */
        if (arr_gruppo_fasi.length == 1) {
          this.input_args = {
            id_utente: localStorage.id,
            id_riferimento: arg.id_commessa,
            cod_riferimento: "commessa",
            pk_riferimento: "id_commessa",
          };
          this.window_frame_allegati_visible = true;
        } else {
          /* Se ho un gruppo con più fasi, faccio scegliere all'utente
           * quella che vuole passare al componente degli allegati. */
          this.items_fasi_selezionabili_allegati = new Array();
          arr_gruppo_fasi.forEach((f) => {
            this.items_fasi_selezionabili_allegati.push({
              id_utente: localStorage.id,
              id_riferimento: Number(f.split("|")[0]),
              cod_riferimento: "commessa",
              pk_riferimento: "id_commessa",
              cod_commessa: f.split("|")[2],
              cod_documento: f.split("|")[3],
            });
          });
          this.dialog_scelta_fase_allegati = true;
        }
      } else {
        // Se non ho un gruppo di fasi, apro gli allegati del WO attuale.
        this.input_args = {
          id_utente: localStorage.id,
          id_riferimento: arg.id_commessa,
          cod_riferimento: "commessa",
          pk_riferimento: "id_commessa",
        };
        this.window_frame_allegati_visible = true;
      }
    },
    async aggiungiWorkOrder(messaggio) {
      // Controllo che la commessa non sia già nel carrello.
      let ricorre = false;

      this.work_orders_in_corso.forEach((elem) => {
        if (
          elem.id_commessa_dettaglio ==
          messaggio.detail.work_order_sel.id_commessa_dettaglio
        ) {
          ricorre = true;
        }
      });

      // Stampo errore se la commessa è già nel carrello.
      if (ricorre == true) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Work Order già presente nel carrello."
        );
        return;
      }

      /* Se è tutto ok aggiungo la commessa al carrello e apro
       * la finestra di evasione della commessa.*/
      let WO_da_aggiungere = Object.assign({}, messaggio.detail.work_order_sel);

      this.work_orders_in_corso.push(WO_da_aggiungere);

      // Se è attivo il parametro di start automatico...
      if (this.start_automatico === 1) {
        // Eseguo la funzione di start automatico.
        await this.$refs.ProduzioneLayoutColumn.setCommessaTempi(
          WO_da_aggiungere,
          1,
          "",
          "on",
          "dialog_off"
        );

        // Aggiorno il carrello.
        this.getWorkOrdersUtente();
      }
    },
    async aggiungiWorkOrderAndStart(messaggio) {
      // Controllo che la commessa non sia già nel carrello.
      let ricorre = false;

      messaggio.detail.workorders.forEach((wo) => {
        this.work_orders_in_corso.forEach((elem) => {
          if (elem.id_commessa_dettaglio == wo.id_commessa_dettaglio) {
            ricorre = true;
          }
        });
      });

      /* Stampo errore se il WO è già nel
       * carrello e non faccio nient'altro. */
      if (ricorre == true) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Work Order già presente nel carrello."
        );
        return;
      }

      /* Se è tutto ok mando gli start in batteria e alla
       * fine di tutto faccio una get per aggiornare i dati.*/
      const WO_da_aggiungere = Array.from(messaggio.detail.workorders);

      /* Tutti i WO mandano la set ma non fanno la
       * get di aggiornamento, tranne l'ultimo WO. */
      for (let i = 0; i < WO_da_aggiungere.length; i++) {
        if (i < WO_da_aggiungere.length - 1) {
          await this.switchStartStop(WO_da_aggiungere[i], "", "off");
        } else {
          await this.switchStartStop(WO_da_aggiungere[i], "", "on");
        }
      }
    },
    async chiudiQuestionarioQualita() {
      // Chiudo la finestra di dialogo.
      this.questionario_qualita_visible = false;

      /* Eseguo la postquery in modo che le eventuali azioni
       * BE successive al salvataggio dei contenuti del dialog
       * possano essere salvate. */
      await this.performPopQuery(this.createStdQueryArr(this.work_order_sel));

      /* Aggiorno i WO, così le eventuali operazioni prenderanno
       * in carico gli esiti dei salvataggi precedenti.*/
      this.getWorkOrdersUtente();
    },
    chiusuraFase() {
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcommessaregistrazioneinsit",
          token: localStorage.getItem("user_token"),
          id_commessa: this.work_order_sel.id_commessa,
          id_commessa_dettaglio: this.work_order_sel.id_commessa_dettaglio,
          id_macchina: this.work_order_sel.id_macchina,
          flag_fase_ultima: this.work_order_sel.flag_fase_ultima,
          flag_em: "",
          id_articolo: this.work_order_sel.id_articolo,
          note: this.note,
          quantita:
            this.work_order_sel.quantita -
            this.work_order_sel.pezzi_avanzati_produzione_fase,
          chiudi_workorder: this.work_order_sempre_aperto == true ? 0 : 1,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.getWorkOrdersUtente();
            this.$refs.SnackbarQV.print(
              "success",
              "Controllo eseguito e produzione registrata!"
            );
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore nella comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          if (err) {
            console.error(err);
            this.$refs.SnackbarQV.print(
              "error",
              "Errora nella comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        });
    },
    async clickAvanzaConfezioni(item) {
      /* Eseguo la prequery del pulsante. La postquery
       * viene eseguita nei diversi metodi di chiusura. */
      this.performPreQuery("AVCONF", this.createStdQueryArr(item));

      this.work_order_sel = Object.assign({}, item);

      /* Prendo i packaging alternativi. Questi packaging saranno filtrati nella
       * prop passata al componente togliendo quello che ha il flag di predefinito. */
      this.opzioni_quantita_alternativa = await this.getArticoloPackaging(
        item.id_articolo
      );

      // Resetto il packaging standard nel caso fosse già stato valorizzato.
      this.pkg_std = new Object();
      this.pkg_std.id_articolo_packaging = null;
      this.pkg_std.qta_confezione = null;

      /* Cerco un packaging standard e se c'è lo uso
       * per valorizzare l'oggetto appena creato. */
      this.opzioni_quantita_alternativa.forEach((o) => {
        if (o.predefinito == 1) {
          this.pkg_std.id_articolo_packaging = o.id_articolo_packaging;
          this.pkg_std.qta_confezione = o.qta_confezione;
        }
      });

      /* Cerco anche il packaging predefinito per cliente.
       * Se lo trovo i dati di questo packaging sovrascriveranno
       * quelli eventualmente già caricati per il packaging
       * prdefinito, come è giusto che sia perché il packaging
       * predefinito per cliente deve avere la precedenza sul
       * packaging predefinito quando scelgo il contenitore standard. */
      this.opzioni_quantita_alternativa.forEach((o) => {
        if (o.id_articolo_packaging == o.id_commessa_packaging_cliente) {
          this.pkg_std.id_articolo_packaging = o.id_articolo_packaging;
          this.pkg_std.qta_confezione = o.qta_confezione;
        }
      });

      // Mostro il dialog dell'avanzamento dei contenitori.
      this.avanza_confezioni_visible = true;
    },
    async clickAvanzaContenitore(item) {
      /* Eseguo la prequery del pulsante. La postquery
       * viene eseguita nei diversi metodi di chiusura. */
      this.performPreQuery("AVPACK", this.createStdQueryArr(item));

      this.work_order_sel = Object.assign({}, item);

      /* Prendo i packaging alternativi. Questi packaging saranno filtrati nella
       * prop passata al componente togliendo quello che ha il flag di predefinito. */
      this.opzioni_quantita_alternativa = await this.getArticoloPackaging(
        item.id_articolo
      );

      // Resetto il packaging standard nel caso fosse già stato valorizzato.
      this.pkg_std = new Object();
      this.pkg_std.id_articolo_packaging = null;
      this.pkg_std.qta_contenitore = null;

      /* Cerco un packaging standard e se c'è lo uso
       * per valorizzare l'oggetto appena creato. */
      this.opzioni_quantita_alternativa.forEach((o) => {
        if (o.predefinito == 1) {
          this.pkg_std.id_articolo_packaging = o.id_articolo_packaging;
          this.pkg_std.qta_contenitore = o.qta_contenitore;
        }
      });

      /* Cerco anche il packaging predefinito per cliente.
       * Se lo trovo i dati di questo packaging sovrascriveranno
       * quelli eventualmente già caricati per il packaging
       * prdefinito, come è giusto che sia perché il packaging
       * predefinito per cliente deve avere la precedenza sul
       * packaging predefinito quando scelgo il contenitore standard. */
      this.opzioni_quantita_alternativa.forEach((o) => {
        if (o.id_articolo_packaging == o.id_commessa_packaging_cliente) {
          this.pkg_std.id_articolo_packaging = o.id_articolo_packaging;
          this.pkg_std.qta_contenitore = o.qta_contenitore;
        }
      });

      // Mostro il dialog dell'avanzamento dei contenitori.
      this.avanza_contenitore_visible = true;
    },
    async clickAvanzaContenitoreSF(item) {
      /* Eseguo la prequery del pulsante. La postquery
       * viene eseguita nei diversi metodi di chiusura. */
      this.performPreQuery("AVPACKSF", this.createStdQueryArr(item));

      this.work_order_sel = Object.assign({}, item);

      /* Prendo i packaging alternativi. Questi packaging saranno filtrati nella
       * prop passata al componente togliendo quello che ha il flag di predefinito. */
      this.opzioni_quantita_alternativa = await this.getArticoloPackaging(
        item.id_articolo
      );

      // Resetto il packaging standard nel caso fosse già stato valorizzato.
      this.pkg_std = new Object();
      this.pkg_std.id_articolo_packaging = null;
      this.pkg_std.qta_contenitore = null;

      /* Cerco un packaging standard e se c'è lo uso
       * per valorizzare l'oggetto appena creato. */
      this.opzioni_quantita_alternativa.forEach((o) => {
        if (o.predefinito == 1) {
          this.pkg_std.id_articolo_packaging = o.id_articolo_packaging;
          this.pkg_std.qta_contenitore = o.qta_contenitore;
        }
      });

      /* Cerco anche il packaging predefinito per cliente.
       * Se lo trovo i dati di questo packaging sovrascriveranno
       * quelli eventualmente già caricati per il packaging
       * prdefinito, come è giusto che sia perché il packaging
       * predefinito per cliente deve avere la precedenza sul
       * packaging predefinito quando scelgo il contenitore standard. */
      this.opzioni_quantita_alternativa.forEach((o) => {
        if (o.id_articolo_packaging == o.id_commessa_packaging_cliente) {
          this.pkg_std.id_articolo_packaging = o.id_articolo_packaging;
          this.pkg_std.qta_contenitore = o.qta_contenitore;
        }
      });

      // Mostro il dialog dell'avanzamento dei contenitori.
      this.avanza_contenitore_sf_visible = true;
    },
    clickPrelievi(item) {
      this.work_order_sel = Object.assign({}, item);

      /* Eseguo la prequery. La postquery viene eseguita
       * dalle gestioni degli eventi di chiusura della
       * finestra di dialogo per la gestione prelievi. */
      this.performPreQuery("LOTTI", this.work_order_sel);

      this.prelievi_visible = true;
    },
    async clickRegistraElementi(arg) {
      /* Eseguo la prequery. La postuery viene eseguita nei
       * metodi di chiusura del dialog. In questo caso è una
       * chiamata di stash perché questo dialog di registrazione
       * sta al centro di diverse procedure di chiusura produzione,
       * sia per il subentro che per il nascondimento del WO. */
      await this.performPreQuery("LAVEL", this.createStdQueryArr(arg));

      // Controllo che ci siano elementi.
      this.work_order_sel = JSON.parse(JSON.stringify(arg));
      const elementi_tmp = await this.getElementi();

      if (elementi_tmp == 0) {
        this.$refs.MultiSnackbarQV.print(
          "orange",
          "Non sono stati trovati elementi per questa commessa."
        );
        return;
      }

      this.registra_elementi_visible = true;
    },
    async clickRegistraFermi(item) {
      this.work_order_sel = JSON.parse(JSON.stringify(item));

      /* Eseguo la prequery. La postquery viene fatta
       * alla chiusura della finestra di dialogo. */
      await this.performPreQuery(
        "DICFERMI",
        this.createStdQueryArr(this.work_order_sel)
      );

      this.registra_fermi_visible = true;
    },
    async clickRegistraPezzi(item) {
      /* Faccio una getworkordersutentegenerale per
       * controllar che il mio pulsante sia ancora cliccabile. */
      await this.getWorkOrdersUtente();

      /* Faccio un controllo per verificare se dopo
       * avere aggiornato i WO c'è (almeno) un pulsante
       * che ha lo stesso codice (campo field) e la visibilità
       * del pulsante a 0. Se questa condizione si verifica
       * vuol dire che il pulsante è disattivato e non vado
       * avanti con la logica, ma stampo un avviso. */
      if (
        this.work_orders_in_corso.filter(
          (e) => e.id_commessa_dettaglio == item.id_commessa_dettaglio
        ).length > 0 &&
        this.work_orders_in_corso
          .filter(
            (e) => e.id_commessa_dettaglio == item.id_commessa_dettaglio
          )[0]
          .autorizzazioni.filter((e) => e.field === "REGPZ" && e.visible == 0)
          .length > 0
      ) {
        this.$refs.SnackbarQV.print("orange", "Eseguire Autocontrollo");
        return;
      }

      /* Eseguo la prequery. La postuery viene eseguita nei
       * metodi di chiusura del dialog. In questo caso è una
       * chiamata di stash perché questo dialog di registrazione
       * sta al centro di diverse procedure di chiusura produzione,
       * sia per il subentro che per il nascondimento del WO. */
      await this.performPreQuery("REGPZ", this.createStdQueryArr(item));

      /* Apro la finestra di dialogo. Alla chiusura della finestra
       * (per ogni evento di chiusura, perché può essercene più di
       * uno) verrà eseguita la postquery di questo pulsante. */
      this.registra_pezzi_visible = true;
      this.work_order_sel = JSON.parse(JSON.stringify(item));
    },
    async clickRegistraScarti(item) {
      this.work_order_sel = JSON.parse(JSON.stringify(item));

      /* Eseguo la prequery. La postquery viene fatta
       * alla chiusura della finestra di dialogo. */
      await this.performPreQuery(
        "DICHSCAR",
        this.createStdQueryArr(this.work_order_sel)
      );

      this.registra_scarti_visible = true;
    },
    clickRegistraPezziAlternativi(item) {
      this.registra_pezzi_alternativi_visible = true;
      this.work_order_sel = JSON.parse(JSON.stringify(item));
    },
    clickRegistraPezziSeriali(item) {
      this.registra_pezzi_seriali_visible = true;
      this.work_order_sel = JSON.parse(JSON.stringify(item));
    },
    async clickRegistraContAlternativi(item) {
      this.work_order_sel = JSON.parse(JSON.stringify(item));

      /* Eseguo la prequery. La postquery viene eseguita
       * alla chiusura della finestra di dialogo. */
      this.performPreQuery(
        "REGALT",
        this.createStdQueryArr(this.work_order_sel)
      );
      this.registra_cont_alternativi_visible = true;
    },
    clickRistampaSeriale(item) {
      this.ristampa_seriale_visible = true;
      this.work_order_sel = JSON.parse(JSON.stringify(item));
    },
    clickStart() {
      this.getWorkOrdersUtente();
    },
    clickStop(commessa, arg_nascondi, arg_dialog) {
      // Ricarico i dati dal BE
      this.caricamento_dati = true;

      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getworkordersutentegenerale",
          token: localStorage.getItem("user_token"),
          cod_commessa: this.filtroEM === "1" ? this.commessa.cod_commessa : "",
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          // Svuoto l'array che contiene le commesse in gestione
          this.work_orders_in_corso = [];

          // Popolo l'array che contiene i dati totali
          res.data.workorders.workorder.forEach((elem) => {
            /* Se ce l'ha, formatto la Produzione reale della fase
             * per convenienza di FE. */
            if (elem.pzhreale != null) {
              elem.pzhreale = elem.pzhreale.toFixed(2);
            }

            /* Se ce l'ha, formatto il tempo ciclo della fase
             * per convenienza di FE. */
            if (elem.tempo_ciclo != null) {
              elem.tempo_ciclo = elem.tempo_ciclo.toFixed(2);
            }

            this.work_orders_in_corso.push(elem);
          });

          this.caricamento_dati = false;

          /* Se sto nascondendo il WO, registro che lo sto nascondendo
           * in modo da far scattare il metodo di nascondimento quando
           * i dialog si chiuderanno. */
          if (arg_nascondi === "nascondi") {
            this.nascondi_WO = true;
          }

          /* Se l'evento che ha lanciato il metodo porta l'informazione di
           * aprire il dialog di registrazione, cerco il Work Order che ho
           * selezionato e ne apro la Dichiarazione. */
          if (arg_dialog === "dialog_on") {
            this.work_orders_in_corso.forEach((elem) => {
              if (
                elem.id_commessa_dettaglio == commessa.id_commessa_dettaglio
              ) {
                /* Se devo aprire un dialog prima di nascondere, decido
                 * in base al flag work_order_sempre_aperto se devo
                 * aprire la finestra di dialogo con chiusura automatica
                 * oppure quella che non chiude mai il WO. */
                this.clickRegistraPezzi(elem);
              }
            });
          } else if (arg_dialog === "dialog_elementi") {
            this.work_orders_in_corso.forEach((elem) => {
              if (
                elem.id_commessa_dettaglio == commessa.id_commessa_dettaglio
              ) {
                this.clickRegistraElementi(elem);
              }
            });
          }
        } else {
          this.$refs.SnackbarQV.print(
            "error",
            `Non è stato possibile caricare i dati: codice errore ${res.status}.`
          );
        }
      });
    },
    clickSubentro(item) {
      /* Se il WO è in stato di fermo gli chiedo
       * di avviarlo prima di fare il subentro. */
      if (
        item.ora_start == null ||
        item.ora_start == "" ||
        (item.ora_start != null &&
          item.ora_start != "" &&
          item.ora_stop != null &&
          item.ora_stop != "")
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il Work Order deve essere avviato per eseguire il subentro."
        );
        return;
      }

      /* Eseguo la prequery. La postquery viene eseguita
       * alla chiusura della finestra di dialogo in una
       * chiamata di stash perché deve essere eseguita
       * quando si chiude la finestra di dialogo di
       * registrazione, che è la stessa interessata dalla
       * procedura di nascondimento WO. */
      this.performPreQuery("SUBENTRO", this.createStdQueryArr(item));

      this.work_order_sel = JSON.parse(JSON.stringify(item));
      this.registra_pezzi_visible = true;
      this.subentro_waiting = true;
    },
    checkControlloQualita() {
      for (let i = 0; i < this.work_orders_in_corso.length; i++) {
        if (this.work_orders_in_corso[i].controllo === 1) {
          this.work_order_sel = Object.assign({}, this.work_orders_in_corso[i]);
          this.controllo_qualita_visible = true;
          return;
        }
      }
    },
    chiudiScatolaStandard(
      id_macchina,
      id_commessa_dettaglio,
      cod_articolo,
      qta_pezzi,
      qta_contenitori
    ) {
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "chiusurascatole",
          token: localStorage.getItem("user_token"),
          id_macchina: id_macchina,
          id_commessa_dettaglio: id_commessa_dettaglio,
          qta_contenitori: qta_contenitori,
          qta_pezzi: qta_pezzi,
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.getWorkOrdersUtente();
            this.$refs.SnackbarQV.print(
              "success",
              `Avanzamento di ${(
                parseFloat(qta_pezzi) * parseInt(qta_contenitori)
              )
                .toFixed(2)
                .replace(
                  ".",
                  ","
                )} unità dell'articolo ${cod_articolo} eseguito con successo!`
            );
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
            return false;
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Non è stato possibile salvare i dati: verificare la quantità di materia prima."
          );
          return false;
        });
    },
    chiudiScatolaStandardSF(
      id_macchina,
      id_commessa_dettaglio,
      cod_articolo,
      qta_pezzi,
      qta_contenitori
    ) {
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "chiusurascatolesf",
          token: localStorage.getItem("user_token"),
          id_macchina: id_macchina,
          id_commessa_dettaglio: id_commessa_dettaglio,
          qta_contenitori: qta_contenitori,
          qta_pezzi: qta_pezzi,
          dati_report: [
            {
              // Il cod_report viene popolato automaticamente dal BE.
              cod_report: "",
              parametri: [
                {
                  simbolo: "@id_macchina",
                  valore: `${this.work_order_sel.id_macchina}`,
                },
                {
                  simbolo: "@seriale",
                  valore: `${this.work_order_sel.id_lotto}`,
                },
                {
                  simbolo: "@id_commessa",
                  valore: `${this.work_order_sel.id_commessa}`,
                },
                {
                  simbolo: "@id_commessa_dettaglio",
                  valore: `${this.work_order_sel.id_commessa_dettaglio}`,
                },
                {
                  simbolo: "@id_commessa_tempi",
                  valore: `${this.work_order_sel.id_commessa_tempi}`,
                },
                {
                  simbolo: "@cod_macchina",
                  valore: `${this.work_order_sel.cod_macchina}`,
                },
                {
                  simbolo: "@qta_contenitori",
                  valore: `${qta_contenitori}`,
                },
                {
                  simbolo: "@qta_pezzi",
                  valore: `${qta_pezzi}`,
                },
                {
                  simbolo: "@id_articolo_packaging",
                  valore: `${this.work_order_sel.id_articolo_packaging}`,
                },
                {
                  simbolo: "@id_articolo",
                  valore: `${this.work_order_sel.id_articolo}`,
                },
                {
                  simbolo: "@cod_articolo",
                  valore: `${this.work_order_sel.cod_articolo}`,
                },
              ],
            },
          ],
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.getWorkOrdersUtente();
            this.items_risme_etichette = new Array();

            // Registro i base64 che il BE mi ha ritornato.
            res.data.result
              .filter((e) => e.statusCode == 200)
              .forEach((r) => {
                const response = r.result;
                const byteCharacters = atob(response);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                  byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {
                  type: "application/pdf",
                });
                const blobUrl = URL.createObjectURL(blob);
                this.items_risme_etichette.push({
                  base64: blobUrl,
                  titolo: r.titolo,
                });
              });

            this.dialog_risme_etichette = true;
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
            return false;
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Non è stato possibile salvare i dati: verificare la quantità di materia prima."
          );
          return false;
        });
    },
    chiudiConfezioneStandardSF(
      id_macchina,
      id_commessa_dettaglio,
      cod_articolo,
      qta_pezzi,
      qta_contenitori
    ) {
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "chiusuraconfezionisf",
          token: localStorage.getItem("user_token"),
          id_macchina: id_macchina,
          id_commessa_dettaglio: id_commessa_dettaglio,
          qta_contenitori: qta_contenitori,
          qta_pezzi: qta_pezzi,
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.getWorkOrdersUtente();
            this.$refs.SnackbarQV.print(
              "success",
              `Avanzamento di ${(
                parseFloat(qta_pezzi) * parseInt(qta_contenitori)
              )
                .toFixed(2)
                .replace(
                  ".",
                  ","
                )} unità dell'articolo ${cod_articolo} eseguito con successo!`
            );
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
            return false;
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Non è stato possibile salvare i dati: verificare la quantità di materia prima."
          );
          return false;
        });
    },
    chiudiDialogPreview() {
      this.dialog_preview = false;
    },
    chiudiScatolaAlternativa(
      id_macchina,
      id_commessa_dettaglio,
      cod_articolo,
      id_contenitore,
      qta_contenitori,
      qta_pezzi
    ) {
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "chiusurascatole",
          token: localStorage.getItem("user_token"),
          id_macchina: id_macchina,
          id_commessa_dettaglio: id_commessa_dettaglio,
          id_contenitore: id_contenitore,
          qta_contenitori: qta_contenitori,
          qta_pezzi: qta_pezzi,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.getWorkOrdersUtente();
            this.$refs.SnackbarQV.print(
              "success",
              `Avanzamento contenitori (quantità ${(
                parseFloat(qta_pezzi) * parseInt(qta_contenitori)
              )
                .toFixed(2)
                .replace(
                  ".",
                  ","
                )} unità) dell'articolo ${cod_articolo} eseguito con successo!`
            );
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
            return false;
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Non è stato possibile salvare i dati: verificare la quantità di materia prima."
          );
          return false;
        });
    },
    chiudiScatolaAlternativaSF(
      id_macchina,
      id_commessa_dettaglio,
      cod_articolo,
      id_contenitore,
      qta_contenitori,
      qta_pezzi
    ) {
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "chiusurascatolesf",
          token: localStorage.getItem("user_token"),
          id_macchina: id_macchina,
          id_commessa_dettaglio: id_commessa_dettaglio,
          id_contenitore: id_contenitore,
          qta_contenitori: qta_contenitori,
          qta_pezzi: qta_pezzi,
          dati_report: [
            {
              cod_report: "REPORT_CONTENITORE_SF",
              parametri: [
                {
                  simbolo: "@id_macchina",
                  valore: `${this.work_order_sel.id_macchina}`,
                },
                {
                  simbolo: "@seriale",
                  valore: `${this.work_order_sel.id_lotto}`,
                },
                {
                  simbolo: "@id_commessa",
                  valore: `${this.work_order_sel.id_commessa}`,
                },
                {
                  simbolo: "@id_commessa_tempi",
                  valore: `${this.work_order_sel.id_commessa_tempi}`,
                },
                {
                  simbolo: "@cod_macchina",
                  valore: `${this.work_order_sel.cod_macchina}`,
                },
                {
                  simbolo: "@qta_contenitori",
                  valore: `${this.qta_contenitori}`,
                },
                {
                  simbolo: "@qta_pezzi",
                  valore: `${this.qta_pezzi}`,
                },
                {
                  simbolo: "@id_articolo_packaging",
                  valore: `${id_contenitore}`,
                },
              ],
            },
          ],
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.getWorkOrdersUtente();
            this.items_risme_etichette = new Array();

            // Registro i base64 che il BE mi ha ritornato.
            res.data.result
              .filter((e) => e.statusCode == 200)
              .forEach((r) => {
                const response = r.result;
                const byteCharacters = atob(response);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                  byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {
                  type: "application/pdf",
                });
                const blobUrl = URL.createObjectURL(blob);
                this.items_risme_etichette.push({
                  base64: blobUrl,
                  titolo: r.titolo,
                });
              });

            this.dialog_risme_etichette = true;
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
            return false;
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Non è stato possibile salvare i dati: verificare la quantità di materia prima."
          );
          return false;
        });
    },
    chiudiConfezioneAlternativaSF(
      id_macchina,
      id_commessa_dettaglio,
      cod_articolo,
      id_contenitore,
      qta_contenitori,
      qta_pezzi
    ) {
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "chiusuraconfezionisf",
          token: localStorage.getItem("user_token"),
          id_macchina: id_macchina,
          id_commessa_dettaglio: id_commessa_dettaglio,
          id_contenitore: id_contenitore,
          qta_contenitori: qta_contenitori,
          qta_pezzi: qta_pezzi,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.getWorkOrdersUtente();
            this.$refs.SnackbarQV.print(
              "success",
              `Avanzamento contenitori (quantità ${(
                parseFloat(qta_pezzi) * parseInt(qta_contenitori)
              )
                .toFixed(2)
                .replace(
                  ".",
                  ","
                )} unità) dell'articolo ${cod_articolo} eseguito con successo!`
            );
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
            return false;
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Non è stato possibile salvare i dati: verificare la quantità di materia prima."
          );
          return false;
        });
    },
    async chiudiScatolaLibera(
      id_macchina,
      id_commessa_dettaglio,
      cod_articolo,
      qta_contenitori,
      qta_pezzi,
      id_causale,
      id_contenitore
    ) {
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "chiusurascatole",
          token: localStorage.getItem("user_token"),
          id_macchina: id_macchina,
          id_commessa_dettaglio: id_commessa_dettaglio,
          qta_contenitori: qta_contenitori,
          qta_pezzi: qta_pezzi,
          id_causale: id_causale,
          id_contenitore: id_contenitore,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.getWorkOrdersUtente();
            this.$refs.SnackbarQV.print(
              "success",
              `Avanzamento contenitori (quantità ${(
                parseFloat(qta_pezzi) * parseInt(qta_contenitori)
              )
                .toFixed(2)
                .replace(
                  ".",
                  ","
                )} unità) dell'articolo ${cod_articolo} eseguito con successo!`
            );
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
            return false;
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Non è stato possibile salvare i dati: verificare la quantità di materia prima."
          );
          return false;
        });
    },
    async chiudiScatolaLiberaSF(
      id_macchina,
      id_commessa_dettaglio,
      cod_articolo,
      qta_contenitori,
      qta_pezzi,
      id_causale,
      id_contenitore
    ) {
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "chiusurascatolesf",
          token: localStorage.getItem("user_token"),
          id_macchina: id_macchina,
          id_commessa_dettaglio: id_commessa_dettaglio,
          qta_contenitori: qta_contenitori,
          qta_pezzi: qta_pezzi,
          id_causale: id_causale,
          id_contenitore: id_contenitore,
          dati_report: [
            {
              cod_report: "REPORT_CONTENITORE_SF",
              parametri: [
                {
                  simbolo: "@id_macchina",
                  valore: `${this.work_order_sel.id_macchina}`,
                },
                {
                  simbolo: "@seriale",
                  valore: `${this.work_order_sel.id_lotto}`,
                },
                {
                  simbolo: "@id_commessa",
                  valore: `${this.work_order_sel.id_commessa}`,
                },
                {
                  simbolo: "@id_commessa_tempi",
                  valore: `${this.work_order_sel.id_commessa_tempi}`,
                },
                {
                  simbolo: "@cod_macchina",
                  valore: `${this.work_order_sel.cod_macchina}`,
                },
                {
                  simbolo: "@qta_contenitori",
                  valore: `${this.qta_contenitori}`,
                },
                {
                  simbolo: "@qta_pezzi",
                  valore: `${this.qta_pezzi}`,
                },
                {
                  simbolo: "@id_articolo_packaging",
                  valore: `${id_contenitore}`,
                },
              ],
            },
          ],
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.getWorkOrdersUtente();
            this.items_risme_etichette = new Array();

            // Registro i base64 che il BE mi ha ritornato.
            res.data.result
              .filter((e) => e.statusCode == 200)
              .forEach((r) => {
                const response = r.result;
                const byteCharacters = atob(response);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                  byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {
                  type: "application/pdf",
                });
                const blobUrl = URL.createObjectURL(blob);
                this.items_risme_etichette.push({
                  base64: blobUrl,
                  titolo: r.titolo,
                });
              });

            this.dialog_risme_etichette = true;
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
            return false;
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Non è stato possibile salvare i dati: verificare la quantità di materia prima."
          );
          return false;
        });
    },
    async chiudiConfezioneLiberaSF(
      id_macchina,
      id_commessa_dettaglio,
      cod_articolo,
      qta_contenitori,
      qta_pezzi,
      id_causale,
      id_contenitore
    ) {
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "chiusuraconfezionisf",
          token: localStorage.getItem("user_token"),
          id_macchina: id_macchina,
          id_commessa_dettaglio: id_commessa_dettaglio,
          qta_contenitori: qta_contenitori,
          qta_pezzi: qta_pezzi,
          id_causale: id_causale,
          id_contenitore: id_contenitore,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.getWorkOrdersUtente();
            this.$refs.SnackbarQV.print(
              "success",
              `Avanzamento contenitori (quantità ${(
                parseFloat(qta_pezzi) * parseInt(qta_contenitori)
              )
                .toFixed(2)
                .replace(
                  ".",
                  ","
                )} unità) dell'articolo ${cod_articolo} eseguito con successo!`
            );
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
            return false;
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Non è stato possibile salvare i dati: verificare la quantità di materia prima."
          );
          return false;
        });
    },
    chiudi_allegato_controllo() {
      this.allegato_controllo_visible = false;
    },
    clickConsuntivoCommesse() {
      this.consuntivo_commesse_visible = true;
    },
    clickVisualizzaAllegatoControllo(item) {
      // Se non ci sono allegati stampo una snackbar di errore.
      if (item.check_allegato == 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Non ci sono allegati per questo Work Order"
        );
      } else {
        // Se invece gli allegati ci sono, faccio la chiamata per averli.
        this.allegato_controllo_visible = true;
        this.work_order_sel = Object.assign({}, item);
      }
    },
    clickVisualizzaDisegno(item) {
      this.performPreQuery("VDIS", this.createStdQueryArr(item));

      if (item.view_disegno == 0) {
        /* Se il disegno non è ancora stato visualizzato mando
         * una chiamata al BE e apro il dialog. */
        let request = {
          controller: "Magazzino",
          method: "PUT",
          richiesta: {
            action: "setviewdisegno",
            token: localStorage.getItem("user_token"),
            id_disegno: item.id_disegno,
          },
        };

        this.$store.dispatch("api", request).then((res) => {
          if (res.status === 200) {
            this.visualizza_disegno_visible = true;
            this.work_order_sel = JSON.parse(JSON.stringify(item));
          } else {
            this.$refs.SnackbarQV.print(
              "error",
              `Non è stato possibile caricare i dati: codice errore ${res.status}.`
            );
          }
        });
      } else {
        /* Se il disegno è già stato visualizzato apro
         * il dialog semplicemente, senza chiamare il BE. */
        this.visualizza_disegno_visible = true;
        this.work_order_sel = JSON.parse(JSON.stringify(item));
      }
    },
    closeAppLoghi() {
      this.dialog_app_loghi = false;
      this.key_idearicamo = this.key_idearicamo == 1 ? 0 : 1;
      this.performPopQuery(this.createStdQueryArr(this.work_order_sel));
    },
    closeNoteCommessa() {
      this.dialog_note_commessa = false;
      this.performPopQuery(this.createStdQueryArr(this.work_order_sel));
    },
    closeNoteFase() {
      this.dialog_note_fase = false;
      this.performPopQuery(this.createStdQueryArr(this.work_order_sel));
    },
    closeNoteFasePrecedente() {
      this.dialog_note_fase_custom = false;
      this.performPopQuery(this.createStdQueryArr(this.work_order_sel));
    },
    closeRegistrazioneImballi() {
      this.dialog_registrazione_imballi = false;
      this.performPopQuery(this.createStdQueryArr(this.work_order_sel));
    },
    closeWindowFrame() {
      this.window_frame_allegati_visible = false;
      this.window_frame_check_visible = false;
      this.window_frame_qm_visible = false;
      this.window_frame_segnalazioni_visible = false;
      if (this.component_window_frame === "check") {
        this.$refs.SnackbarQV.print("orange", "Questionario sospeso!");
      }

      // Mi creo l'oggetto da passare alla postquery
      let obj_tmp = new Object();

      this.work_orders_in_corso.forEach((wo) => {
        if (
          wo.id_commessa_dettaglio == this.work_order_sel.id_commessa_dettaglio
        ) {
          obj_tmp = JSON.parse(JSON.stringify(wo));
        }
      });

      // Eseguo la postuery.
      this.performPopQuery(this.createStdQueryArr(obj_tmp));
    },
    confermaEseguiCheck(arg) {
      // Imposto i dati per lanciare il questionario.
      this.component_window_frame = "check";
      this.input_args = {
        toolbar_visible: false,
        dizionario: new Object(),
        esterno: 1,
      };

      this.input_args.id_questionario = arg.id_modulo;
      this.input_args.id_relazione = arg.id_relazione;
      this.input_args.id_relazione_log = arg.id_relazione_log;
      this.landing_page_check = "quiz_detail/" + arg.id_modulo;

      /* Eseguo la prequery. La postquery viene eseguita quando
       * si chiude la finestra di dialogo di WindowFrame. */
      this.performPreQuery(
        "CHECK",
        this.createStdQueryArr(this.work_order_sel)
      );

      /* Se c'è un base64 per l'immagine, lo cancello altrimenti
       * gli argomenti pasati a QuickCheck sarebbero troppi e
       * non riuscirei ad aprire il modulo esterno. */
      if (this.input_args.dizionario.immagine_preview) {
        delete this.input_args.dizionario.immagine_preview;
      }

      this.input_args.esterno = 1;

      this.key_window_frame = this.key_window_frame == 0 ? 1 : 0;

      /* Lancio il questionario e metto a false
       * l'eventuale finestra di dialogo per confermare
       * o negare la volontà dell'utente di rispondere
       * a un questionario opzionale. */
      this.window_frame_check_visible = true;

      this.conferma_check_visible = false;
    },
    createStdQueryArr(arg_obj) {
      const arr_params = [{ name: "id_utente", value: localStorage.id }];

      for (let field in arg_obj) {
        if (field != "autorizzazioni" && field != "immagine_preview") {
          arr_params.push({
            name: field,
            value: arg_obj[field],
          });
        }
      }

      return arr_params;
    },
    dialogClose() {
      this.dialog_Richieste = false;
    },
    getElementi() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getcommessaelementi",
          token: localStorage.user_token,
          id_commessa: this.work_order_sel.id_commessa,
        },
      };

      this.caricamento_dati = true;
      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati = false;
          if (res.status === 200) {
            return res.data.result.elementi.length;
          } else {
            this.$refs.MultiSnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
            return 0;
          }
        })
        .catch((err) => {
          this.caricamento_dati = false;
          console.error(err);
          this.$refs.MultiSnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
          return 0;
        });
    },
    getWorkOrders() {
      this.consuntivo_commesse_visible = true;

      // this.caricamento_dati = true;

      // let request = {
      //   controller: "Magazzino",
      //   method: "POST",
      //   richiesta: {
      //     action: "getworkorders",
      //     token: localStorage.getItem("user_token"),
      //     cod_commessa: this.cod_commessa,
      //     filtroEM: this.filtroEM,
      //   },
      // };

      // this.$store.dispatch("api", request).then((res) => {
      //   if (res.status === 200) {
      //     // Svuoto l'array che contiene le commesse in gestione
      //     this.work_orders_totali = [];

      //     /* Popolo l'array che contiene i dati totali
      //      * inserendo solo le fasi con id_stato fase diverso
      //      * da 1 (ovvero le fasi che non sono chiuse). */
      //     res.data
      //       .filter((e) => e.id_stato_fase != 1)
      //       .forEach((elem) => {
      //         elem.selezionato = false;
      //         this.work_orders_totali.push(elem);
      //       });

      //     // Apro il dialog delle fasi avviabili.
      //     this.consuntivo_commesse_visible = true;
      //   } else {
      //     this.$refs.SnackbarQV.print(
      //       "error",
      //       `Non è stato possibile caricare i dati, codice errore: ${res.status}.`
      //     );
      //   }

      //   // Fermo l'overlay di caricamento.
      //   this.caricamento_dati = false;
      // });
    },
    getListaMacchine() {
      let request = {
        controller: "Manutenzione",
        method: "POST",
        richiesta: {
          action: "getlistamacchine",
          token: localStorage.getItem("user_token"),
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          res.data.macchine.forEach((m) => {
            if (m.multi_commessa == 1) {
              delete m.macchina_img;
              this.items_macchine_multi.push(m);
            }
          });
        }
      });
    },
    getQuickLabelAllowed() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getmodulialternativi",
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            if (!res.data.result) {
              return;
            }

            // Se l'array di risposta è vuoto non faccio nulla
            if (!res.data.result.length > 0) {
              return;
            }

            // Se l'array contiene informazioni su QuickLabel, le registro.
            if (
              res.data.result.filter(
                (e) => e.descrizione === "MODULO_QUICKLABEL"
              ).length > 0
            ) {
              this.quicklabel_allowed = res.data.result.filter(
                (e) => e.descrizione === "MODULO_QUICKLABEL"
              )[0].val_int;
            }

            // Se l'array contiene informazioni sull'abilitazione della picking, le registro.
            if (
              res.data.result.filter(
                (e) => e.descrizione === "PICKING_AVANZAMENTO_ALLOWED"
              ).length > 0
            ) {
              this.picking_allowed = res.data.result.filter(
                (e) => e.descrizione === "PICKING_AVANZAMENTO_ALLOWED"
              )[0].val_int;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore nella comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore nella comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    getRelazioniModuli(codice_btn) {
      const request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "getrelazionimoduli",
          token: localStorage.user_token,
          codice: codice_btn,
          id_riferimento: this.work_order_sel.id_commessa_dettaglio,
          id_personale: localStorage.id,
          riferimento: "commessa_dettaglio",
          modulo: "questionario",
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            if (res.data.result.dati.length > 0) {
              let object = {
                id_relazione: res.data.result.dati[0].id_relazione,
                id_modulo: res.data.result.dati[0].id_start,
                exec: res.data.result.dati[0]._exec,
                id_relazione_log: res.data.result.dati[0].id_relazione_log,
              };
              return object;
            } else {
              return {
                exec: "N",
              };
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },
    getWorkOrdersUtente() {
      this.caricamento_dati = true;

      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getworkordersutentegenerale",
          token: localStorage.getItem("user_token"),
          cod_commessa: this.filtroEM === "1" ? this.commessa.cod_commessa : "",
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati = false;
          if (res.status === 200) {
            // Svuoto l'array che contiene le commesse in gestione
            this.work_orders_in_corso = [];

            // Popolo l'array che contiene le fasi in gestione
            res.data.workorders.workorder.forEach((elem) => {
              /* Se ce l'ha, formatto la Produzione reale della fase
               * per convenienza di FE. */
              if (elem.pzhreale != null) {
                elem.pzhreale = elem.pzhreale.toFixed(2);
              }

              /* Se ce l'ha, formatto il tempo ciclo della fase
               * per convenienza di FE. */
              if (elem.tempo_ciclo != null) {
                elem.tempo_ciclo = elem.tempo_ciclo.toFixed(2);
              }

              this.work_orders_in_corso.push(elem);
            });
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Non è stato possibile caricare i dati, codice errore: ${res.status}.`
            );
            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            `Errore di comunicazione col server, non è stato possibile caricare i dati.`
          );
          return false;
        });
    },
    handleAnomalieLoaded() {
      this.$refs.windowframe_segnalazioni.postEvent("setparams", {
        cod_articolo: this.work_order_sel.cod_articolo,
        num_documento: this.work_order_sel.cod_fase,
        cod_documento: this.work_order_sel.cod_commessa,
      });
    },
    handleClickChiusuraMassivaFasi(arg) {
      this.work_order_sel = JSON.parse(JSON.stringify(arg));
      this.dialog_chiusura_massiva_fasi = true;
      this.key_dialog_chiusura_massiva_fasi =
        this.key_dialog_chiusura_massiva_fasi == 0 ? 1 : 0;
    },
    handleClickRegistraArtRes(arg) {
      this.work_order_sel = JSON.parse(JSON.stringify(arg));
      this.dialog_registra_art_res = true;
      this.key_registra_art_res = this.key_registra_art_res == 0 ? 1 : 0;
    },
    handleClickRegistraPeso() {
      this.key_dialog_registra_peso =
        this.key_dialog_registra_peso == 0 ? 1 : 0;
      this.dialog_registra_peso = true;
    },
    handleClickRiaperturaMaster() {
      this.dialog_riapertura_master = true;
      //this.work_order_sel = JSON.parse(JSON.stringify(arg));
    },
    handleAllegatiFase(arg) {
      this.performPreQuery("ALLEGATO", this.createStdQueryArr(arg));

      this.work_order_sel = Object.assign({}, arg);
      this.key_allegati = this.key_allegati === 0 ? 1 : 0;
      this.gestione_allegati_visible = true;
    },
    handleCheckLoaded() {
      this.$refs.windowframe_check.postEvent("setparams", {
        dizionario: JSON.parse(JSON.stringify(this.work_order_sel)),
        landing_page: this.landing_page_check,
      });
    },
    handleClickApplicazioneLoghi(arg) {
      this.input_args = {
        from_avanzamento: 1,
        work_order: { id_commessa: arg.id_commessa },
      };
      this.$nextTick(() => {
        this.dialog_app_loghi = true;
      });
    },
    async handleClickBackRegPz() {
      /* Questa funzione vale sia per la registrazione dei
       * pezzi che per la registrazione degli elementi. */
      this.registra_elementi_visible = false;
      this.registra_pezzi_visible = false;

      if (this.subentro_waiting === true) {
        this.subentro_waiting = false;
        this.subentro_visible = true;
      }

      /* Se è in corso una procedura di nascondimento,
       * eseguo la funzione debita. Questa funzione
       * esegue internamente lo stash dello stack. */
      if (this.nascondi_WO === true) {
        this.nascondi_WO = false;
        this.nascondiWorkOrder(this.work_order_sel);
      } else {
        /* In condizioni normali (non di nascondimento)
         * eseguo lo stash dello stack ed aggiorno
         * l'elenco dei work orders attualmente caricati. */
        await this.performStashQuery(
          this.createStdQueryArr(this.work_order_sel)
        );
        this.getWorkOrdersUtente();
      }
    },
    async handleClickBackRegContAlt() {
      await this.performPopQuery(this.work_order_sel);
      this.registra_cont_alternativi_visible = false;
    },
    handleClickBackRegFermi() {
      this.registra_fermi_visible = false;

      this.performPopQuery(this.createStdQueryArr(this.work_order_sel));
    },
    handleClickBackRegPzAlt() {
      this.registra_pezzi_alternativi_visible = false;
      if (this.subentro_waiting === true) {
        this.subentro_waiting = false;
        this.subentro_visible = true;
      }

      if (this.nascondi_WO === true) {
        this.nascondi_WO = false;
        this.nascondiWorkOrder(this.work_order_sel);
      }
    },
    handleClickBackRegPzSeriali() {
      this.registra_pezzi_seriali_visible = false;
    },
    handleClickBackRegScarti() {
      this.registra_scarti_visible = false;

      this.performPopQuery(this.createStdQueryArr(this.work_order_sel));
    },
    handleClickManutenzione() {
      this.component_window_frame = "qm";
      this.input_args = {
        id_commessa_dettaglio: this.work_order_sel.id_commessa_dettaglio,
        id_macchina: this.work_order_sel.id_macchina,
        id_personale: this.work_order_sel.id_personale,
      };

      // Eseguo la postquery.
      this.performPreQuery(
        "MANUTENZIONE",
        this.createStdQueryArr(this.work_order_sel)
      );

      this.key_window_frame = this.key_window_frame == 0 ? 1 : 0;
      this.window_frame_qm_visible = true;
    },
    async handleClickCheck(arg, codice_btn, stack_obj) {
      // Registro il WO cliccato.
      this.work_order_sel = Object.assign({}, arg);

      /* Mi metto da parte l'oggetto che contiene le
       * informazioni sul questionario a cui devo rispondere. */
      const getrelazioni_tmp = await this.getRelazioniModuli(codice_btn);

      /* In base alla risposta del server, decido come regolare
       * il comportamento della logica di QuickCheck. */
      switch (getrelazioni_tmp.exec) {
        case "S":
          /* Se ho appena finito di eseguire un questionario
           * con esito positivo non chiedo più al BE se ci sono
           * questionari da eseguire e vado avanti con la normale
           * logica della funzione. */
          if (this.quest_app_exec_ok === true) {
            this.quest_app_exec_ok = false;
            return "N";
          }

          /* ... Altrimenti evo rispondere al questionario, quindi
           * metto i dati della funzione in uno stack di attesa. */
          stack_obj.obbligatorieta = "S";
          this.stack_check.push(stack_obj);

          this.confermaEseguiCheck(getrelazioni_tmp);
          return "S";
        case "N":
          return "N";
        case "X":
          /* Se getrelazioni è null lo valorizzo con l'oggetto
           * contenente le informazioni del questionario, se invece
           * non lo è vuol dire che sono già passato di qui e che ora
           * sto negando di voler eseguire un questionario opzionale
           * quindi ritornerò N come se non ci fosse alcun questionario
           * da fare. */
          if (this.getrelazioni === null) {
            this.getrelazioni = getrelazioni_tmp;

            /* Potrei rispondere al questionario: apro
             * la finestra di dialogo e mi metto da parte
             * il metodo che dovrebbe essere eseguito. Se
             * l'utente dice che non vuole eseguire il
             * questionario, lancio il metodo che mi sono
             * messo da parte. */
            stack_obj.obbligatorieta = "X";
            this.stack_check.push(stack_obj);
            this.conferma_check_visible = true;

            /* Ritorno S per far fermare la logica della
             * funzione chiamante nel componente figlio. */
            return "S";
          } else {
            this.getrelazioni = null;
            return "N";
          }

        default:
          return "N";
      }
    },
    handleClickChiudiPrelievi(arg_bool) {
      this.prelievi_visible = false;

      if (arg_bool === true) {
        /* Devo controllare se ci sono questionari da eseguire in chiusura
         * del dialog. Per farlo uso la funzione handleClickCheck che è la
         * stessa che viene usata per sapere se ci sono questionari da
         * eseguire al click su qualsiasi bottone del cruscotto di
         * avanzamento. Mi metto da parte il WO attualmente selezionato
         * e lo passo alla funzione. Le passo anche un codice univoco
         * che identifica la chiusura di questo specifico dialog e una
         * funzione vuota e innocua perché una volta finito il
         * questionario non voglio che vanga fatto più nulla di specifico.*/
        const obj_tmp = JSON.parse(JSON.stringify(this.work_order_sel));

        let that = this;

        const stack_obj = {
          funzione: function () {
            that.handleClickChiudiPrelievi(arg_bool);
          },
        };

        this.handleClickCheck(obj_tmp, "CLS_PRELIEVI_AVANZAMENTO", stack_obj);

        // Eseguo la postquery.
        this.performPopQuery(this.createStdQueryArr(obj_tmp));
      }
    },
    handleClickChiudiProseguiPrelievi() {
      this.prelievi_visible = false;

      // Eseguo la postquery.
      this.performPopQuery(this.createStdQueryArr(this.work_order_sel));
    },
    handleClickHistory(arg) {
      this.work_order_sel = Object.assign({}, arg);
      this.history_dialog = true;
    },
    async handleClickIndietroRegistraTempi() {
      this.registra_tempi_visible = !this.registra_tempi_visible;

      // Aggiorno i dati della tabella.
      await this.getWorkOrdersUtente();

      // Mi creo l'oggetto da passare alla postquery
      let obj_tmp = new Object();

      this.work_orders_in_corso.forEach((wo) => {
        if (
          wo.id_commessa_dettaglio == this.work_order_sel.id_commessa_dettaglio
        ) {
          obj_tmp = JSON.parse(JSON.stringify(wo));
        }
      });

      // Eseguo la postuery.
      this.performStashQuery(this.createStdQueryArr(obj_tmp));

      /* Se devo eseguire un subentro, apro
       * la relativa finestra di dialogo. */
      if (this.subentro_waiting === true) {
        this.subentro_waiting = false;
        this.subentro_visible = true;
      }

      // Se devo nascondere il WO, lo nascondo.
      if (this.nascondi_WO === true) {
        this.nascondi_WO = false;
        this.nascondiWorkOrder(this.work_order_sel);
      }
    },
    async handleClickLavoroSquadra(arg) {
      this.work_order_sel = JSON.parse(JSON.stringify(arg));

      await this.performPreQuery(
        "LAVTEAM",
        this.createStdQueryArr(this.work_order_sel)
      );

      this.lavoro_squadra_visible = true;
    },
    async handleClickQuestionarioQualita(arg_wo, arg_questionario) {
      // Eseguo la logica di prequery.
      await this.performPreQuery("QQUAL", this.createStdQueryArr(arg_wo));

      /* Registro il work order selezionato e i dati
       * del questionario per passarli come props. */
      this.work_order_sel = JSON.parse(JSON.stringify(arg_wo));
      this.props_questionario_qualita = Object.assign({}, arg_questionario);

      this.questionario_qualita_visible = true;
      this.key_questionario_qualita =
        this.key_questionario_qualita === 0 ? 1 : 0;
    },
    handleClickRegistraImballi(arg) {
      this.work_order_sel = JSON.parse(JSON.stringify(arg));
      this.performPreQuery(
        "REGIMB",
        this.createStdQueryArr(this.work_order_sel)
      );
      this.dialog_registrazione_imballi = true;
    },
    handleClickSegnalazione(arg) {
      this.work_order_sel = JSON.parse(JSON.stringify(arg));
      this.component_window_frame = "anomalie";
      this.input_args = {
        clear_on_save: true,
        destinazione: "",
        disegni_iniziali: [],
        id_articolo: 0,
        id_riferimento: this.work_order_sel.id_commessa_dettaglio,
        immagine_standard_editor: "",
        pk_riferimento: "id_commessa_dettaglio",
        riferimento: "commessa_dettaglio",
        return_array: true,
        show_close_button: true,
        show_editor_arrow_button: true,
        show_editor_camera_button: true,
        show_editor_circle_button: true,
        show_editor_color_picker_button: true,
        show_editor_crop_button: true,
        show_editor_edit_back_button: true,
        show_editor_edit_forward_button: true,
        show_editor_eraser_button: true,
        show_editor_free_draw_button: true,
        show_editor_large_size_button: true,
        show_editor_letter_case_button: true,
        show_editor_medium_size_button: true,
        show_editor_save_button: true,
        show_editor_small_size_button: true,
        show_editor_square_button: true,
        show_editor_tool_columns: true,
        show_editor_upload_button: true,
        tabella_supporto: "disegno",
        titolo_editor: "Editor",
        visible: true,
      };

      // Eseguo la postquery.
      this.performPreQuery(
        "SIGNAL",
        this.createStdQueryArr(this.work_order_sel)
      );

      this.key_window_frame = this.key_window_frame == 0 ? 1 : 0;
      this.window_frame_segnalazioni_visible = true;
    },
    handleClosedDettaglioPackaging() {
      this.performPopQuery(this.createStdQueryArr(this.work_order_sel));
    },
    handleCloseLavoroSquadra() {
      this.lavoro_squadra_visible = false;

      // Eseguo la postquery.
      this.performPopQuery(this.createStdQueryArr(this.work_order_sel));
    },
    handleCloseSubentro() {
      this.subentro_visible = false;
    },
    handleConfigAvvioMultiploWo(arg) {
      this.avvio_multiplo_enabled = arg;
    },
    async handleCredInv(arg_nominativo) {
      this.subentro_visible = false;
      this.$refs.SnackbarQV.print(
        "success",
        `Subentro di ${arg_nominativo} eseguito con successo.`
      );

      await this.getWorkOrdersUtente();

      /* Se nel carrello c'è ancora il WO che la setsubentro
       * dovrebbe aver già nascosto, forzo il nascondimento
       * chiamando la funzione hideworkorder. */
      if (
        this.work_orders_in_corso.filter(
          (w) =>
            w.id_commessa_dettaglio == this.work_order_sel.id_commessa_dettaglio
        ).length > 0
      ) {
        // La hideworkorder aggiorna anche automaticamente i dati del carrello.
        this.nascondiWorkOrder(this.work_order_sel);
      }
    },
    handleFineSessioneCheck(arg) {
      if (arg.punteggio == null) {
        this.$refs.SnackbarQV.print("orange", "Questionario sospeso!");
      }

      if (arg.punteggio < 100) {
        // Stampo una snackbar di avviso.
        this.$refs.SnackbarQV.print(
          "orange",
          `Questionario completato con punteggio ${
            arg.punteggio == null ? "N/D" : arg.punteggio
          }!`
        );

        /* Mando una chiamata che mi genera una
         * segnalazione se il BE trova i flag giusti. */
        this.setSegnalazioneQuestionario({
          id_ciclo_fasi: this.work_order_sel.id_ciclo_fasi,
          id_commessa_dettaglio: this.work_order_sel.id_commessa_dettaglio,
          id_questionario: arg.id_questionario,
        });
      }

      if (arg.punteggio == 100) {
        this.$refs.SnackbarQV.print(
          "success",
          `Questionario completato con punteggio ${
            arg.punteggio == null ? "N/D" : arg.punteggio
          }!`
        );
      }

      this.window_frame_check_visible = false;

      if (this.stack_check[0]) {
        if (
          this.stack_check[0].obbligatorieta == "X" ||
          (this.stack_check[0].obbligatorieta == "S" && arg.punteggio == 100)
        ) {
          // Registro di aver appena eseguito un questionario.
          this.quest_app_exec_ok = true;

          // Eseguo la funzione che sta attendendo nello stack.
          this.stack_check[0].funzione();

          // Azzero l'array di stack.
          this.stack_check = new Array();
        }
      } else {
        this.getWorkOrdersUtente();
      }
    },
    async handleFineQuestionarioQualita(arg) {
      /* Se sono qui vuol dire che ho terminato un questionario
       * e che devo stampare un avviso di completamento e
       * chiudere la finestra di dialogo in cui è avvenuta la
       * compilazione. Poi eseguirò una postquery con condice QQUAL. */

      this.questionario_qualita_visible = false;

      const color_tmp = arg == 100 ? "success" : "orange";

      this.$refs.SnackbarQV.print(
        color_tmp,
        `Questionario completato con punteggio ${arg == null ? "N/D" : arg}!`
      );

      /* Eseguo una postquery che in teoria esegue solo
       * la postquery con codice QQUAL. */
      await this.performPopQuery(this.createStdQueryArr(this.work_order_sel));

      // Ricarico i WO aggiornati.
      this.getWorkOrdersUtente();
    },
    handleIdHeaderQuery(arg) {
      this.id_header_query = arg;
    },
    handleNoteCommessa(arg) {
      this.work_order_sel = Object.assign({}, arg);
      /* Controllo che ci siano note commessa da
       * visualizzare, altrimenti non apro nulla. */
      if (
        this.work_order_sel.note_commessa == null ||
        this.work_order_sel.note_commessa == ""
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Non ci sono note da visualizzare per questa commessa."
        );
        return;
      }

      this.performPreQuery(
        "COMNOTE",
        this.createStdQueryArr(this.work_order_sel)
      );
      this.dialog_note_commessa = true;
    },
    handleNoteFase(arg) {
      this.work_order_sel = Object.assign({}, arg);
      /* Controllo che ci siano note commessa da
       * visualizzare, altrimenti non apro nulla. */
      if (
        this.work_order_sel.note_fase == null ||
        this.work_order_sel.note_fase == ""
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Non ci sono note da visualizzare per questa fase."
        );
        return;
      }

      this.performPreQuery(
        "FASENOTE",
        this.createStdQueryArr(this.work_order_sel)
      );
      this.dialog_note_fase = true;
    },
    handleNoteFasePrecedente(arg) {
      this.work_order_sel = Object.assign({}, arg);

      this.performPreQuery(
        "FASENOTE2",
        this.createStdQueryArr(this.work_order_sel)
      );
      this.dialog_note_fase_custom = true;
    },
    async handleCloseAvanzaConfezioni(
      tipo_contenitore,
      id_contenitore,
      workorder,
      qta_contenitori,
      qta_pezzi,
      id_causale
    ) {
      this.avanza_confezioni_visible = false;

      /* Se non c'è un tipo di contenitore vuol
       * dire che ho veramente soltanto chiuso. */
      if (tipo_contenitore == null) {
        return;
      }

      // Se invece ho i dati, eseguo la chiamata debita.
      if (tipo_contenitore == "standard") {
        await this.chiudiConfezioneStandardSF(
          workorder.id_macchina,
          workorder.id_commessa_dettaglio,
          workorder.cod_articolo,
          qta_contenitori,
          qta_pezzi
        );
      } else if (tipo_contenitore == "alternativa") {
        const contenitore_alternativo = this.opzioni_quantita_alternativa.find(
          (item) => item.id_articolo_packaging == id_contenitore
        );

        await this.chiudiConfezioneAlternativaSF(
          workorder.id_macchina,
          workorder.id_commessa_dettaglio,
          workorder.cod_articolo,
          contenitore_alternativo.id_articolo_contenitore,
          qta_contenitori,
          qta_pezzi,
          id_causale
        );
      } else {
        await this.chiudiConfezioneLiberaSF(
          workorder.id_macchina,
          workorder.id_commessa_dettaglio,
          workorder.cod_articolo,
          qta_contenitori,
          qta_pezzi,
          id_causale,
          id_contenitore
        );
      }

      // Mi creo l'oggetto da passare alla postquery
      let obj_tmp = new Object();

      this.work_orders_in_corso.forEach((wo) => {
        if (
          wo.id_commessa_dettaglio == this.work_order_sel.id_commessa_dettaglio
        ) {
          obj_tmp = JSON.parse(JSON.stringify(wo));
        }
      });

      // Eseguo la postuery.
      this.performPopQuery(this.createStdQueryArr(obj_tmp));
    },
    async handleCloseAvanzaContenitore(
      tipo_contenitore,
      id_contenitore,
      workorder,
      qta_contenitori,
      qta_pezzi,
      id_causale
    ) {
      this.avanza_contenitore_visible = false;

      /* Se non c'è un tipo di contenitore vuol
       * dire che ho veramente soltanto chiuso. */
      if (tipo_contenitore == null) {
        return;
      }

      // Se invece ho i dati, eseguo la chiamata debita.
      if (tipo_contenitore == "standard") {
        await this.chiudiScatolaStandard(
          workorder.id_macchina,
          workorder.id_commessa_dettaglio,
          workorder.cod_articolo,
          qta_contenitori,
          qta_pezzi
        );
      } else if (tipo_contenitore == "alternativa") {
        const contenitore_alternativo = this.opzioni_quantita_alternativa.find(
          (item) => item.id_articolo_packaging == id_contenitore
        );

        await this.chiudiScatolaAlternativa(
          workorder.id_macchina,
          workorder.id_commessa_dettaglio,
          workorder.cod_articolo,
          contenitore_alternativo.id_articolo_contenitore,
          qta_contenitori,
          qta_pezzi,
          id_causale
        );
      } else {
        await this.chiudiScatolaLibera(
          workorder.id_macchina,
          workorder.id_commessa_dettaglio,
          workorder.cod_articolo,
          qta_contenitori,
          qta_pezzi,
          id_causale,
          id_contenitore
        );
      }

      // Mi creo l'oggetto da passare alla postquery
      let obj_tmp = new Object();

      this.work_orders_in_corso.forEach((wo) => {
        if (
          wo.id_commessa_dettaglio == this.work_order_sel.id_commessa_dettaglio
        ) {
          obj_tmp = JSON.parse(JSON.stringify(wo));
        }
      });

      // Eseguo la postuery.
      this.performPopQuery(this.createStdQueryArr(obj_tmp));
    },
    async handleCloseAvanzaContenitoreSF(
      tipo_contenitore,
      id_contenitore,
      workorder,
      qta_contenitori,
      qta_pezzi,
      id_causale
    ) {
      this.avanza_contenitore_sf_visible = false;

      /* Se non c'è un tipo di contenitore vuol
       * dire che ho veramente soltanto chiuso. */
      if (tipo_contenitore == null) {
        return;
      }

      // Se invece ho i dati, eseguo la chiamata debita.
      if (tipo_contenitore == "standard") {
        await this.chiudiScatolaStandardSF(
          workorder.id_macchina,
          workorder.id_commessa_dettaglio,
          workorder.cod_articolo,
          qta_contenitori,
          qta_pezzi
        );
      } else if (tipo_contenitore == "alternativa") {
        const contenitore_alternativo = this.opzioni_quantita_alternativa.find(
          (item) => item.id_articolo_packaging == id_contenitore
        );

        await this.chiudiScatolaAlternativaSF(
          workorder.id_macchina,
          workorder.id_commessa_dettaglio,
          workorder.cod_articolo,
          contenitore_alternativo.id_articolo_contenitore,
          qta_contenitori,
          qta_pezzi,
          id_causale
        );
      } else {
        await this.chiudiScatolaLiberaSF(
          workorder.id_macchina,
          workorder.id_commessa_dettaglio,
          workorder.cod_articolo,
          qta_contenitori,
          qta_pezzi,
          id_causale,
          id_contenitore
        );
      }

      // Mi creo l'oggetto da passare alla postquery
      let obj_tmp = new Object();

      this.work_orders_in_corso.forEach((wo) => {
        if (
          wo.id_commessa_dettaglio == this.work_order_sel.id_commessa_dettaglio
        ) {
          obj_tmp = JSON.parse(JSON.stringify(wo));
        }
      });

      // Eseguo la postuery.
      this.performPopQuery(this.createStdQueryArr(obj_tmp));
    },
    handleAddMultiRegistrazione() {
      this.macchine_multi_visible = true;
    },
    handleCampionatura(arg) {
      /* Se il WO è in stato di fermo gli chiedo
       * di avviarlo prima di fare i controlli. */
      if (
        arg.ora_start == null ||
        arg.ora_start == "" ||
        (arg.ora_start != null &&
          arg.ora_start != "" &&
          arg.ora_stop != null &&
          arg.ora_stop != "")
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Il Work Order deve essere avviato prima di eseguire il controllo."
        );
        return;
      }

      this.work_order_sel = Object.assign({}, arg);

      /* Eseguo la prequery. La postquery viene eseguita
       * nella gestione dei vari eveti di chiusura del
       * componente per l'esecuzione del controllo qualità. */
      this.performPreQuery(
        "CAMPIONATURA",
        this.createStdQueryArr(this.work_order_sel)
      );

      /* Rendo visibile la finestra di dialogo
       * per eseguire il controllo qualità.*/
      this.campionatura_visible = true;
    },
    async handleClickAvantiRegistraPezzi() {
      this.registra_pezzi_visible = !this.registra_pezzi_visible;
      this.registra_tempi_visible = true;

      await this.getWorkOrdersUtente();
    },
    handleChiusuraFase(arg) {
      this.work_order_sel = Object.assign({}, arg);

      /* Eseguo la prequery. La postquery viene eseguita
       * nella gestione dei vari eveti di chiusura del
       * componente per l'esecuzione del controllo qualità. */
      this.performPreQuery(
        "CHIUFS",
        this.createStdQueryArr(this.work_order_sel)
      );

      /* Controllo con una chiamata se ci sono elementi del ciclo. */
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getciclocontrolli",
          token: localStorage.user_token,
          id_articolo: this.work_order_sel.id_articolo,
          id_commessa_dettaglio: this.work_order_sel.id_commessa_dettaglio,
          id_fase: this.work_order_sel.id_fase,
          ora_start: this.work_order_sel.ora_start,
          quantita: this.work_order_sel.quantita,
          tipo: "CONTROLLO",
        },
      };

      this.caricamento_dati = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati = false;
          if (res.status === 200) {
            if (res.data.length > 0) {
              this.controllo_qualita_chiusura_fase = true;
            } else {
              this.$refs.SnackbarQV.print(
                "orange",
                "Nessun ciclo di autocontrollo è stato trovato: verificare che i dati della commessa siano aggiornati."
              );
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    handleControlloMP(arg) {
      this.work_order_sel = Object.assign({}, arg);

      /* Eseguo la prequery. La postquery viene eseguita
       * nella gestione dei vari eveti di chiusura del
       * componente per l'esecuzione del controllo qualità. */
      this.performPreQuery(
        "CONTROLLOMP",
        this.createStdQueryArr(this.work_order_sel)
      );

      /* Rendo visibile la finestra di dialogo
       * per eseguire il controllo qualità.*/
      this.controllo_qualita_mp_visible = true;
    },
    async handleClickAvantiRegistraTempi() {
      this.registra_tempi_visible = false;
      this.$refs.SnackbarQV.print(
        "success",
        "Registrazione dei dati avvenuta con successo!"
      );

      // Preparo l'oggetto per la chiamata di postquery.
      let obj_tmp = new Object();

      this.work_orders_in_corso.forEach((wo) => {
        if (
          wo.id_commessa_dettaglio == this.work_order_sel.id_commessa_dettaglio
        ) {
          obj_tmp = JSON.parse(JSON.stringify(wo));
        }
      });

      // Eseguo la postquery di registrazione.
      await this.performStashQuery(this.createStdQueryArr(obj_tmp));

      // Aggiorno i dati della tabella.
      await this.getWorkOrdersUtente();

      // Se devo far scattare il cruscotto di subentro, lo apro.
      if (this.subentro_waiting === true) {
        this.subentro_waiting = false;
        this.subentro_visible = true;
      }

      // Se devo nascondere il WO, lo nascondo.
      if (this.nascondi_WO === true) {
        this.nascondi_WO = false;
        this.nascondiWorkOrder(this.work_order_sel);
      }
    },
    handleClickIndietro() {
      this.$emit("click_indietro");
    },
    handleCloseContQual() {
      this.controllo_qualita_visible = false;
      this.campionatura_visible = false;
      this.controllo_qualita_mp_visible = false;
      this.controllo_qualita_chiusura_fase = false;
    },
    handleControlloQualita(arg) {
      this.work_order_sel = Object.assign({}, arg);

      /* Eseguo la prequery. La postquery viene eseguita
       * nella gestione dei vari eveti di chiusura del
       * componente per l'esecuzione del controllo qualità. */
      this.performPreQuery(
        "CONTROLLO",
        this.createStdQueryArr(this.work_order_sel)
      );

      /* Rendo visibile la finestra di dialogo
       * per eseguire il controllo qualità.*/
      this.controllo_qualita_visible = true;
    },
    handleRegAvvImballi() {
      this.getWorkOrdersUtente();
    },
    async handleRegCampionatura() {
      this.campionatura_visible = false;
      await this.getWorkOrdersUtente();
      this.$refs.SnackbarQV.print("success", "Campionatura eseguita!");

      // Preparo l'oggetto per la chiamata di postquery.
      let obj_tmp = new Object();

      this.work_orders_in_corso.forEach((wo) => {
        if (
          wo.id_commessa_dettaglio == this.work_order_sel.id_commessa_dettaglio
        ) {
          obj_tmp = JSON.parse(JSON.stringify(wo));
        }
      });

      this.performPopQuery(this.createStdQueryArr(obj_tmp));
    },
    async handleRegInv(printSnackbar) {
      this.controllo_qualita_chiusura_fase = false;
      this.controllo_qualita_visible = false;
      this.campionatura_visible = false;
      this.controllo_qualita_mp_visible = false;

      await this.getWorkOrdersUtente();
      if (printSnackbar) {
        this.$refs.SnackbarQV.print("success", "Controllo eseguito!");
      }

      // Preparo l'oggetto per la chiamata di postquery.
      let obj_tmp = new Object();

      this.work_orders_in_corso.forEach((wo) => {
        if (
          wo.id_commessa_dettaglio == this.work_order_sel.id_commessa_dettaglio
        ) {
          obj_tmp = JSON.parse(JSON.stringify(wo));
        }
      });

      this.performPopQuery(this.createStdQueryArr(obj_tmp));
    },
    handleRegistrateFasiCommessa() {
      this.dialog_chiusura_massiva_fasi = false;
      this.getWorkOrdersUtente();
      this.$refs.SnackbarQV.print(
        "success",
        "Chiusura massiva avvenuta con successo."
      );
    },
    async handleRegistratoQrCode() {
      this.avanza_contenitore_sf_visible = false;
      this.avanza_contenitore_visible = false;
      this.avanza_confezioni_visible = false;
      this.$refs.SnackbarQV.print(
        "success",
        "Avanzamento registrato con successo!"
      );

      await this.getWorkOrdersUtente();

      // Preparo l'oggetto per la chiamata di postquery.
      let obj_tmp = new Object();

      this.work_orders_in_corso.forEach((wo) => {
        if (
          wo.id_commessa_dettaglio == this.work_order_sel.id_commessa_dettaglio
        ) {
          obj_tmp = JSON.parse(JSON.stringify(wo));
        }
      });

      this.performPopQuery(this.createStdQueryArr(obj_tmp));
    },
    async handleSalvaRegistraContAlt() {
      this.registra_cont_alternativi_visible = false;
      this.$refs.SnackbarQV.print(
        "success",
        "Registrazione avvenuta con successo!"
      );

      await this.performPopQuery(this.work_order_sel);
      // Aggiorno i dati della tabella
      this.getWorkOrdersUtente();
    },
    handleRegistraFaseCarrello() {
      this.dialog_registra_peso = false;
      this.getWorkOrdersUtente();
      this.$refs.SnackbarQV.print(
        "success",
        "Registrazione avvenuta con successo."
      );
    },
    handleRiaperturaMaster(arg) {
      this.dialog_riapertura_master = false;
      this.$refs.SnackbarQV.print(
        "success",
        `Il master ${arg} è stato riaperto: è ora possibile associare gli slave.`
      );
      this.getWorkOrdersUtente();
    },
    async handleSalvaRegistraElementi() {
      this.registra_elementi_visible = !this.registra_elementi_visible;
      this.$refs.SnackbarQV.print(
        "success",
        "Lavorazione elementi registrata!"
      );

      // Aggiorno i dati della tabella
      await this.getWorkOrdersUtente();

      // Preparo l'oggetto per la chiamata di postquery.
      let obj_tmp = new Object();

      this.work_orders_in_corso.forEach((wo) => {
        if (
          wo.id_commessa_dettaglio == this.work_order_sel.id_commessa_dettaglio
        ) {
          obj_tmp = JSON.parse(JSON.stringify(wo));
        }
      });

      // Eseguo la postquery del pulsante di registrazione.
      this.performPopQuery(this.createStdQueryArr(obj_tmp));
    },
    handleSalvaRegistraFermi() {
      this.registra_fermi_visible = !this.registra_fermi_visible;
      this.$refs.SnackbarQV.print(
        "success",
        "Registrazione avvenuta con successo!"
      );

      // Aggiorno i dati della tabella
      this.getWorkOrdersUtente();

      /* Lancio la postquery. Popolo il suo dizionario
       * con il work_order_sel, che tanto non è cambiato. */
      this.performPopQuery(this.createStdQueryArr(this.work_order_sel));
    },
    async handleSalvaRegistraPezzi() {
      this.registra_pezzi_visible = !this.registra_pezzi_visible;
      this.$refs.SnackbarQV.print(
        "success",
        "Registrazione avvenuta con successo!"
      );

      // Apro la finestra di dialogo dei tempi
      this.registra_tempi_visible = true;

      // Aggiorno i dati della tabella
      await this.getWorkOrdersUtente();

      // Preparo l'oggetto per la chiamata di postquery.
      let obj_tmp = new Object();

      this.work_orders_in_corso.forEach((wo) => {
        if (
          wo.id_commessa_dettaglio == this.work_order_sel.id_commessa_dettaglio
        ) {
          obj_tmp = JSON.parse(JSON.stringify(wo));
        }
      });

      // Eseguo la postquery del pulsante di registrazione.
      this.performPopQuery(this.createStdQueryArr(obj_tmp));
    },
    handleSalvaRegistraScarti() {
      this.registra_scarti_visible = !this.registra_scarti_visible;
      this.$refs.SnackbarQV.print(
        "success",
        "Registrazione avvenuta con successo!"
      );

      // Aggiorno i dati della tabella
      this.getWorkOrdersUtente();

      /* Lancio la postquery. Popolo il suo dizionario
       * con il work_order_sel, che tanto non è cambiato. */
      this.performPopQuery(this.createStdQueryArr(this.work_order_sel));
    },
    handleSalvaRegistraPezziAlt() {
      this.registra_pezzi_alternativi_visible =
        !this.registra_pezzi_alternativi_visible;
      this.$refs.SnackbarQV.print(
        "success",
        "Registrazione avvenuta con successo!"
      );

      // Aggiorno i dati della tabella
      this.getWorkOrdersUtente();
    },
    handleSalvaRegistraPezziSeriali(arg_arr) {
      this.registra_pezzi_seriali_visible =
        !this.registra_pezzi_seriali_visible;

      this.$refs.SnackbarQV.print(
        "success",
        "Registrazione avvenuta con successo!"
      );

      this.openDialogReportSeriali(arg_arr);

      // Aggiorno i dati della tabella
      this.getWorkOrdersUtente();
    },
    handleSalvatiArticoliResidui() {
      this.dialog_registra_art_res = false;
      this.$refs.SnackbarQV.print("success", "Articoli residui salvati.");
    },
    handleSalvatiDisegni(arg) {
      const obj_tmp = {
        id_segnalazione: -1,
        pk_riferimento: arg.pk_riferimento,
        id_riferimento: arg.id_riferimento,
        riferimento: arg.riferimento,
        tipo: arg.tipologia,
        note: arg.descrizione,
      };

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setsegnalazioni",
          segnalazioni: [obj_tmp],
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            const request2 = {
              controller: "Magazzino",
              method: "PUT",
              richiesta: {
                action: "setsegnalazioniimmagini",
                token: localStorage.user_token,
                immagini: arg.imgs,
                id_segnalazione: res.data.segnalazioni[0].id_segnalazione,
              },
            };

            this.$store
              .dispatch("api", request2)
              .then((res2) => {
                if (res2.status === 200) {
                  this.window_frame_segnalazioni_visible = false;
                  this.$refs.SnackbarQV.print(
                    "success",
                    "Segnalazione registrata con successo!"
                  );
                }
              })
              .catch((err) => {
                console.error(err);
                this.$refs.SnackbarQV.print(
                  "error",
                  "Errore di comunicazione col server, non è stato possibile salvare le segnalazioni."
                );
              });
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare le segnalazioni."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare le segnalazioni."
          );
        });
    },
    handleSalvatiDisegniSegnalazione(arg) {
      const obj_tmp = {
        id_segnalazione: -1,
        pk_riferimento: arg.pk_riferimento,
        id_riferimento: arg.id_riferimento,
        riferimento: arg.riferimento,
        quantita: arg.quantita,
        tipo: arg.tipologia,
        note: arg.descrizione,
        cod_articolo: this.work_order_sel.cod_articolo,
        cod_documento: "Commessa " + this.work_order_sel.cod_commessa,
        num_documento: this.work_order_sel.cod_fase,
        data_documento: moment().format("YYYY-MM-DD HH:mm:ss"),
      };

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setsegnalazioni",
          segnalazioni: [obj_tmp],
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            const request2 = {
              controller: "Magazzino",
              method: "PUT",
              richiesta: {
                action: "setsegnalazioniimmagini",
                token: localStorage.user_token,
                immagini: arg.imgs,
                id_segnalazione: res.data.segnalazioni[0].id_segnalazione,
              },
            };

            this.$store
              .dispatch("api", request2)
              .then((res2) => {
                if (res2.status === 200) {
                  this.window_frame_segnalazioni_visible = false;
                  this.$refs.SnackbarQV.print(
                    "success",
                    "Segnalazione registrata con successo!"
                  );
                }
              })
              .catch((err) => {
                console.error(err);
                this.$refs.SnackbarQV.print(
                  "error",
                  "Errore di comunicazione col server, non è stato possibile salvare le segnalazioni."
                );
              });
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare le segnalazioni."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare le segnalazioni."
          );
        });
    },
    handleSalvatoLavoro() {
      this.lavoro_squadra_visible = false;

      // Eseguo la postquery.
      this.performPopQuery(this.createStdQueryArr(this.work_order_sel));
    },
    async handleSchedaPackaging(arg) {
      this.articolo_per_packaging = Object.assign(
        {},
        {
          id_articolo: arg.id_articolo,
        }
      );

      // Eseguo la prequery.
      this.work_order_sel = JSON.parse(JSON.stringify(arg));
      this.performPreQuery(
        "SPACK",
        this.createStdQueryArr(this.work_order_sel)
      );

      const that = this;
      this.$nextTick(async () => {
        /* Mi faccio dare dal BE le testate dei vari contenitori
         * disponibili per l'articolo in questione. */
        that.caricamento_dati = true;
        const fetch = await that.$refs.packaging2.fetchPackaging();
        // Se effettivamente sono stati trovati dei contenitori...
        if (
          fetch === true &&
          that.$refs.packaging2.items_contenitori_alternativi.length > 0
        ) {
          // Cerco il contenitore associato a questa commessa e ne apro il dettaglio.
          that.caricamento_dati = false;
          that.$refs.packaging2.items_contenitori_alternativi.forEach(
            async (e) => {
              if (e.id_articolo_packaging == arg.id_articolo_packaging) {
                that.caricamento_dati = true;
                await that.$refs.packaging2.modificaContenitore(e);
                that.caricamento_dati = false;
              } else {
                this.$refs.SnackbarQV.print(
                  "orange",
                  "Non sono state trovate associazioni di packaging per questo WO."
                );
              }
            }
          );
        } else {
          that.caricamento_dati = false;
          that.$refs.SnackbarQV.print(
            "orange",
            "Non sono stati trovati packaging per questo articolo."
          );
        }
      });
    },
    handleSavedDettaglioPackaging() {
      this.performPopQuery(this.createStdQueryArr(this.work_order_sel));
    },
    handleSchedaRichieste() {
      this.dialog_Richieste = true;
    },
    handleSelezionataMacchina(arg_id) {
      /* Filtro fra i work order in corso solo quelli associati alla macchina selezionata
       * e gli aggiungo un campo sel per lavorare con la checkbox nel dialog che aprirò */
      this.items_wo_multi = this.work_orders_in_corso.filter(
        (w) => w.id_macchina == arg_id
      );

      this.items_wo_multi.forEach((w) => (w.sel = false));

      // Chiudo il dialog di selezione della macchina per la multicommessa
      this.macchine_multi_visible = false;

      // Rendo visibile il dialog di selezione dei workorder per la multiregistrazione
      this.consuntivo_wo_multi_visible = true;
    },
    handleSelezionatiWO(arg_arr) {
      // Chiudo il dialog di selezione.
      this.consuntivo_wo_multi_visible = false;

      // Registro i WO che mi sono stati inviati
      this.items_wo_multi_reg_pezzi = new Array();
      arg_arr.forEach((w) => this.items_wo_multi_reg_pezzi.push(w));

      // Apro il dialog di registrazione multipla.
      this.key_registra_pezzi_multi =
        this.key_registra_pezzi_multi === 0 ? 1 : 0;
      this.registra_pezzi_multi_visible = true;
    },
    async handleUpdatePrelievi() {
      // Aggiorno i dati dei miei WO
      await this.getWorkOrdersUtente();

      // Ripesco dai dati aggiornati la versione aggiornata del mio WO selezionato.
      this.work_orders_in_corso.forEach((wo) => {
        if (
          wo.id_commessa_dettaglio === this.work_order_sel.id_commessa_dettaglio
        ) {
          this.work_order_sel = JSON.parse(JSON.stringify(wo));
        }
      });
    },
    handleWOSerialeCompletato(arg_arr) {
      this.$refs.SnackbarQV.print("success", "Work Order Completato!");
      this.handleSalvaRegistraPezziSeriali(arg_arr);
    },
    nascondiWorkOrder(item) {
      this.caricamento_dati = true;

      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "hideworkorder",
          token: localStorage.getItem("user_token"),
          id_commessa_dettaglio: item.id_commessa_dettaglio,
        },
      };

      this.$store
        .dispatch("api", request)
        .then(async (res) => {
          this.caricamento_dati = false;
          if (res.status === 200) {
            await this.performStashQuery(this.createStdQueryArr(item));
            this.getWorkOrdersUtente();
          } else {
            this.$refs.SnackbarQV.print(
              "error",
              `Non è stato possibile caricare i dati, codice errore: ${res.status}.`
            );
          }
        })
        .catch((err) => {
          this.caricamento_dati = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    redirect() {
      this.$router.push("/home/production/controllo");
    },
    saveNoteFase() {
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setnotefase",
          token: localStorage.user_token,
          testo: this.work_order_sel.note_fase,
          id_commessa_dettaglio: this.work_order_sel.id_commessa_dettaglio,
        },
      };

      this.caricamento_dati = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati = false;
          if (res.status === 200) {
            this.$refs.SnackbarQV.print("success", "Note fase aggiornate.");
            this.closeNoteFasePrecedente();
            this.getWorkOrdersUtente();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.caricamento_dati = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    setSegnalazioneQuestionario(arg) {
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          token: localStorage.user_token,
          action: "setsegnalazionequestionario",
          id_ciclo_fasi: arg.id_ciclo_fasi,
          id_commessa_dettaglio: arg.id_commessa_dettaglio,
          id_questionario: arg.id_questionario,
          cod_documento: "Commessa",
          num_documento: this.work_order_sel.cod_commessa,
          data_documento: moment().format("YYYY-MM-DD HH:mm:ss"),
          cod_articolo: this.work_order_sel.cod_articolo,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            // Se tutto è andato ok, non faccio nulla.
            return;
          } else {
            // Se qualcosa è andato storto stampo una snackbar di errore.
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server nella generazione di una segnalazione."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server nella generazione di una segnalazione."
          );
        });
    },
    snackbarOpen() {
      // Funzione lanciata per segnalare allegati che non hanno la descrizione.
      this.$refs.SnackbarQV.print(
        "orange",
        "Aggiungere ad ogni Allegato dell'attività una descrizione."
      );
    },
    validaDisegno(arg) {
      // Chiudo il dialog di visualizzazione dei disegni.
      this.visualizza_disegno_visible = false;

      /* Metto a 1 la visione del disegno per tutti
       * gli oggetti che hanno questo id_ disegno. */
      this.work_orders_in_corso.forEach((elem) => {
        if (elem.id_disegno == arg.id_disegno) {
          elem.view_disegno = 1;
        }
      });

      /* Eseguo la postquery cercando la versione
       * aggiornata dell'oggetto selezionato. */
      this.work_orders_in_corso.forEach((wo) => {
        if (
          this.work_order_sel.id_commessa_dettaglio == wo.id_commessa_dettaglio
        ) {
          this.performPopQuery(this.createStdQueryArr(wo));
        }
      });
    },
    async handleWorkOrderCompletato() {
      // Stampo un avviso e chiudo il dialog
      this.$refs.SnackbarQV.print("success", "Work Order Completato!");
      this.registra_pezzi_visible = !this.registra_pezzi_visible;

      // Aggiorno i dati della tabella
      await this.getWorkOrdersUtente();

      // Preparo l'oggetto per la chiamata di postquery.
      let obj_tmp = new Object();

      this.work_orders_in_corso.forEach((wo) => {
        if (
          wo.id_commessa_dettaglio == this.work_order_sel.id_commessa_dettaglio
        ) {
          obj_tmp = JSON.parse(JSON.stringify(wo));
        }
      });

      // Eseguo la postquery del pulsante di registrazione.
      this.performStashQuery(this.createStdQueryArr(obj_tmp));
    },
    handleWorkOrderAltCompletato() {
      // Stampo un avviso e chiudo il dialog
      this.$refs.SnackbarQV.print("success", "Work Order Completato!");
      this.registra_pezzi_alternativi_visible =
        !this.registra_pezzi_alternativi_visible;

      // Aggiorno i dati della tabella.
      this.getWorkOrdersUtente();
    },
    getArticolo(id_articolo) {
      return new Promise((resolve) => {
        let request = {
          controller: "Magazzino",
          method: "POST",
          richiesta: {
            action: "getarticoli",
            token: localStorage.user_token,
            id_articolo: id_articolo,
          },
        };
        this.$store.dispatch("api", request).then((res) => {
          resolve(res.data.articolo[0]);
        });
      });
    },
    getArticoloPackaging(id_articolo) {
      return new Promise((resolve) => {
        let request = {
          controller: "Magazzino",
          method: "POST",
          richiesta: {
            action: "getarticolipackaging",
            token: localStorage.getItem("user_token"),
            db_name: "quickproduction",
            id_utente: localStorage.id,
            id_articolo: id_articolo,
            id_commessa: this.work_order_sel.id_commessa,
          },
        };

        this.$store.dispatch("api", request).then((res) => {
          resolve(res.data);
        });
      });
    },
    getIntervalloWorkOrders() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getmodulialternativi",
          token: localStorage.user_token,
          codice: "AVANZAMENTO",
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            if (!res.data.result) {
              this.intervallo_work_orders = 0;
              this.start_automatico = 0;
              return 0;
            }

            // Se l'array di risposta è vuoto non faccio nulla
            if (!res.data.result.length > 0) {
              this.intervallo_work_orders = 0;
              this.start_automatico = 0;
              return 0;
            }

            // Se l'array contiene informazioni sull'intervallo della getworkorders, le registro.
            if (
              res.data.result.filter(
                (e) => e.descrizione === "intervallo getworkorders"
              ).length > 0
            ) {
              this.intervallo_work_orders = res.data.result.filter(
                (e) => e.descrizione === "intervallo getworkorders"
              )[0].val_int;
            }

            // Se l'array contiene informazioni sullo start automatico, le registro.
            if (
              res.data.result.filter(
                (e) => e.descrizione === "START_AUTOMATICO"
              ).length > 0
            ) {
              this.start_automatico = res.data.result.filter(
                (e) => e.descrizione === "START_AUTOMATICO"
              )[0].val_int;
            }

            return 0;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore nella comunicazione col server, non è stato possibile caricare i dati."
            );
            return 1;
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore nella comunicazione col server, non è stato possibile caricare i dati."
          );
          return 1;
        });
    },
    noConfermaEseguiCheck() {
      this.conferma_check_visible = false;

      if (this.stack_check[0]) {
        // Eseguo la funzione che sta attendendo nello stack.
        this.stack_check[0].funzione();

        // Elimino l'elemento che ho appena eseguito.
        this.stack_check.splice(1, 1);
      }
    },
    openDialogReportSeriali(arg_arr) {
      // Controllo che ci sia un report associato all'articolo.
      if (this.work_order_sel.id_report == null) {
        return;
      }

      this.dialog_report_seriali = true;
      this.items_seriali = arg_arr;
    },
    performPopQuery(arr_parametri) {
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setqueryevent",
          token: localStorage.user_token,
          tipo: "pre",
          codice: this.$store.state.stack_query.pop(),
          params: arr_parametri,
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            return true;
          } else {
            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },
    performPreQuery(arg_cod_pulsante, arg_parametri) {
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setqueryevent",
          token: localStorage.user_token,
          tipo: "pre",
          codice: arg_cod_pulsante,
          params: arg_parametri,
        },
      };

      this.caricamento_dati = true;
      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati = false;
          if (res.status === 200) {
            this.$store.state.stack_query.push(arg_cod_pulsante);
            return true;
          } else {
            return false;
          }
        })
        .catch((e) => {
          this.caricamento_dati = false;
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },
    async performStashQuery(arg_arr) {
      // Se lo stack è vuoto non faccio nulla.
      if (this.$store.state.stack_query.length == 0) {
        return;
      } else {
        // Se lo stack non è vuoto itero i codici ed eseguo le postquery.
        for (let i = this.$store.state.stack_query.length; i > 0; i--) {
          await this.performPopQuery(arg_arr);
        }
      }
    },
    selezionaCommessaAllegati(arg) {
      this.input_args = JSON.parse(JSON.stringify(arg));
      this.window_frame_allegati_visible = true;
    },
    setSwitchStartStop(arg) {
      /* Se sto avviando più WO in fila (per un avvio multiplo di WO)
       * ho bisogno di accedere a una funzione contenuta nelle colonne.
       * Per averla a disposizione senza patemi, quando il componente
       * rileva per la prima volta il mount di un sottocomponente delle
       * colonne, la prima volta che intercetta l'evento gli crea un
       * puntatore alla funzione che mi interessa così ci posso riaccedere
       * senza temere che venga lanciata più volte o che non sia aspettabile. */
      if (this.set_start_happened === false) {
        this.switchStartStop = arg;

        /* Metto a true il semaforo così non rieseguo
         * questa operazione inutilmente. */
        this.set_start_happened = true;
      }
    },
    showPdfViewer(arg) {
      this.iframeUrl = arg.base64;
      this.dialog_preview = true;
    },
  },
  async mounted() {
    await this.getIntervalloWorkOrders();
    if (this.intervallo_work_orders > 0) {
      this.interval = setInterval(() => {
        this.getWorkOrdersUtente();
      }, this.intervallo_work_orders);
    }

    /* Resetto lo stack_query nella remota possibilità che sia
     * rimasto popolato male da una sessione precedente. */
    this.$store.state.stack_query = new Array();

    // Aggancio al cruscotto i listener di supporto che mi servono.
    document
      .getElementById("listener_Produzione2")
      .addEventListener("clicked_row", this.aggiungiWorkOrder);

    document
      .getElementById("listener_Produzione2")
      .addEventListener("clicked_row_start_it", this.aggiungiWorkOrderAndStart);

    /*this.$SSEController.addEventListener(
      "aggiornato_stato_commesse",
      this.getWorkOrdersUtente
    );*/

    /* Controllo se QuickLabel è abilitato, nel caso l'utente
     * debba usare la modifica del packaging dal carrello.*/
    this.getQuickLabelAllowed();
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }

    if (document.getElementById("listener_Produzione2")) {
      document
        .getElementById("listener_Produzione2")
        .removeEventListener("clicked_row", this.aggiungiWorkOrder);

      document
        .getElementById("listener_Produzione2")
        .removeEventListener(
          "clicked_row_start_it",
          this.aggiungiWorkOrderAndStart
        );
    }

    /*this.$SSEController.removeEventListener(
      "aggiornato_stato_commesse",
      this.getWorkOrdersUtente
    );*/
  },
};
</script>
<style scoped>
@keyframes controtazione {
  0% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes rotazione {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.controruota {
  animation: controtazione 1s infinite;
  animation-timing-function: linear;
}
.ruota {
  animation: rotazione 1s infinite;
  animation-timing-function: linear;
}
</style>
